/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable max-lines */
import { getIntegrationEhrProvider } from '@/atoms/integrationAtoms';
import {
  GET_ONBOARDING_V2_VARIANT,
  type OnboardingV2Variant,
} from '@/components/constants/flags';
import {
  type OrganizationTemplateChangedBy,
  type OrganizationTemplateUsedFor,
} from '@/container/organization/type';
import { getCachedKindeRegion } from '@/hooks/query/useQueryKindeProperties';
import { type TabType } from '@/hooks/query/useQuerySessionWindows';
import {
  getAppType,
  getInstallSourceAnalyticsTraits,
  getPlatform,
  getScreenDimensions,
  segmentClient,
} from '@/lib/analytics/legacy-sender-context';
import { pushGtmDataLayerEvent } from '@/lib/analytics/pushGtmDataLayerEvent';
import {
  askAiAddAsNewOutput as askAiAddAsNewOutputHost,
  askAiAddToNote as askAiAddToNoteHost,
  askAiCopy as askAiCopyHost,
  askAi as askAiHost,
  askAiRegenerate as askAiRegenerateHost,
  askAiReplaceNote as askAiReplaceNoteHost,
  askHeidiCitationClicked as askHeidiCitationClickedHost,
  askHeidiClosed as askHeidiClosedHost,
  askHeidiCsatModalOpened as askHeidiCsatModalOpenedHost,
  askHeidiOpened as askHeidiOpenedHost,
  noteInsertApplied as noteInsertAppliedHost,
} from '@/lib/analytics/scribe/ask-ai';
import { assistantPanelAction as assistantPanelActionHost } from '@/lib/analytics/scribe/assistant-view';
import {
  audioWarningAccepted as audioWarningAcceptedHost,
  audioWarningViewed as audioWarningViewedHost,
} from '@/lib/analytics/scribe/audio';
import {
  resetIdentity as resetIdentityHost,
  setActiveTeam as setActiveTeamHost,
  setAuthTypeUserProperty as setAuthTypeUserPropertyHost,
  trackNativeAuthenticated as trackNativeAuthenticatedHost,
  trackSignInSuccessfulWebAuth as trackSignInSuccessfulWebAuthHost,
  trackSignUpSuccessfulWebAuth as trackSignUpSuccessfulWebAuthHost,
} from '@/lib/analytics/scribe/auth';
import {
  trackBookDemoCliniciansSelected as trackBookDemoCliniciansSelectedHost,
  trackBookDemoCountrySelected as trackBookDemoCountrySelectedHost,
  trackBookDemoFormSubmitted as trackBookDemoFormSubmittedHost,
  trackBookDemoNextClicked as trackBookDemoNextClickedHost,
} from '@/lib/analytics/scribe/book-demo';
import { trackButtonClicked as trackButtonClickedHost } from '@/lib/analytics/scribe/button';
import {
  trackChatCreated as trackChatCreatedHost,
  trackChatDeleted as trackChatDeletedHost,
  trackChatMessageSubmitted as trackChatMessageSubmittedHost,
  trackChatModeToggled as trackChatModeToggledHost,
  trackChatStreamInterrupted as trackChatStreamInterruptedHost,
  trackChatViewed as trackChatViewedHost,
} from '@/lib/analytics/scribe/chat';
import {
  trackClinicalCodeCopied as trackClinicalCodeCopiedHost,
  trackCodingSidebarOpened as trackCodingSidebarOpenedHost,
} from '@/lib/analytics/scribe/clinical-codes';
import {
  trackCommunityTemplateImported as trackCommunityTemplateImportedHost,
  trackCommunityTemplateLiked as trackCommunityTemplateLikedHost,
  trackCommunityTemplatePublished as trackCommunityTemplatePublishedHost,
  trackCommunityTemplateSearched as trackCommunityTemplateSearchedHost,
  trackCommunityTemplateUnliked as trackCommunityTemplateUnlikedHost,
  trackCommunityTemplateViewed as trackCommunityTemplateViewedHost,
} from '@/lib/analytics/scribe/community';
import {
  trackAskHeidiComplianceBlock as trackAskHeidiComplianceBlockHost,
  trackNhsTemplateComplianceBlock as trackNhsTemplateComplianceBlockHost,
  trackNhsTemplateComplianceWarning as trackNhsTemplateComplianceWarningHost,
} from '@/lib/analytics/scribe/compliance';
import { trackContactSalesFormSubmitted as trackContactSalesFormSubmittedHost } from '@/lib/analytics/scribe/contact';
import { trackContactSalesFormOpened as trackContactSalesFormOpenedHost } from '@/lib/analytics/scribe/contact-sales';
import { contextAddContent as contextAddContentHost } from '@/lib/analytics/scribe/context';
import {
  deleteContextFiles as deleteContextFilesHost,
  saveContextFilesUpdates as saveContextFilesUpdatesHost,
  uploadContextFileFailed as uploadContextFileFailedHost,
  uploadContextFiles as uploadContextFilesHost,
  uploadContextFileSuccess as uploadContextFileSuccessHost,
  uploadContextSingleFile as uploadContextSingleFileHost,
} from '@/lib/analytics/scribe/context-files';
import { trackLegacyInlineDictationCompleted as trackLegacyInlineDictationCompletedHost } from '@/lib/analytics/scribe/dictation';
import {
  documentCreateClick as documentCreateClickHost,
  documentCreatedByAICommand as documentCreatedByAICommandHost,
  documentCreatedByAskAI as documentCreatedByAskAIHost,
  documentCreatedByTemplate as documentCreatedByTemplateHost,
  documentDeleted as documentDeletedHost,
  documentRedo as documentRedoHost,
  documentRegeneratedByAskAI as documentRegeneratedByAskAIHost,
  documentRegeneratedByTemplate as documentRegeneratedByTemplateHost,
  documentSelectionCopyAll as documentSelectionCopyAllHost,
  documentSelectionRegenerateOutput as documentSelectionRegenerateOutputHost,
  documentSelectionSaveAsNew as documentSelectionSaveAsNewHost,
  documentSelectionSendEmail as documentSelectionSendEmailHost,
  documentSelectionSetAsDefaultTemplate as documentSelectionSetAsDefaultTemplateHost,
  documentSelectionViewStructure as documentSelectionViewStructureHost,
  documentSyncChangesClicked as documentSyncChangesClickedHost,
  documentUndo as documentUndoHost,
  noteSelectionRegenerateOutput as noteSelectionRegenerateOutputHost,
} from '@/lib/analytics/scribe/document';
import {
  documentExportDoc as documentExportDocHost,
  documentExported as documentExportedHost,
  documentExportPdf as documentExportPdfHost,
  documentPrintedV2 as documentPrintedV2Host,
  trackDocumentGenerated as trackDocumentGeneratedHost,
  trackDocumentTemplateQueueLimitReached as trackDocumentTemplateQueueLimitReachedHost,
  trackDocumentTemplateQueueReordered as trackDocumentTemplateQueueReorderedHost,
  trackQueuedDocumentGenerationCancelled as trackQueuedDocumentGenerationCancelledHost,
  trackQueuedDocumentGenerationFailed as trackQueuedDocumentGenerationFailedHost,
  trackQueuedDocumentGenerationStarted as trackQueuedDocumentGenerationStartedHost,
  trackQueuedDocumentTabTemplateSwapped as trackQueuedDocumentTabTemplateSwappedHost,
  trackSessionStartedWithDocumentQueue as trackSessionStartedWithDocumentQueueHost,
} from '@/lib/analytics/scribe/documents';
import {
  type TauriErrorEventPayload,
  trackTauriErrorEvent as trackTauriErrorEventHost,
} from '@/lib/analytics/scribe/errors';
import {
  trackEvidenceChatAborted as trackEvidenceChatAbortedHost,
  trackEvidenceChatCompleted as trackEvidenceChatCompletedHost,
  trackEvidenceChatError as trackEvidenceChatErrorHost,
  trackEvidenceChatSidebarClose as trackEvidenceChatSidebarCloseHost,
  trackEvidenceChatSidebarOpen as trackEvidenceChatSidebarOpenHost,
  trackEvidenceChatSubmitted as trackEvidenceChatSubmittedHost,
  trackEvidenceClickPastSessionClicked as trackEvidenceClickPastSessionClickedHost,
  trackEvidenceDeepLinkSignInClicked as trackEvidenceDeepLinkSignInClickedHost,
  trackEvidenceDeepLinkSignUpClicked as trackEvidenceDeepLinkSignUpClickedHost,
  trackEvidenceDeleteChatClicked as trackEvidenceDeleteChatClickedHost,
  trackEvidenceJurisdictionChanged as trackEvidenceJurisdictionChangedHost,
  trackEvidenceLanguageChanged as trackEvidenceLanguageChangedHost,
  trackEvidenceNewChatClicked as trackEvidenceNewChatClickedHost,
  trackEvidenceNhsContactSalesSubmitted as trackEvidenceNhsContactSalesSubmittedHost,
  trackEvidenceOnboardingDismissed as trackEvidenceOnboardingDismissedHost,
  trackEvidenceOnboardingSaved as trackEvidenceOnboardingSavedHost,
  trackEvidenceOnboardingSkipped as trackEvidenceOnboardingSkippedHost,
  trackEvidenceOnboardingViewed as trackEvidenceOnboardingViewedHost,
  trackEvidenceProTrialButtonStarted as trackEvidenceProTrialButtonStartedHost,
  trackEvidenceSaveChatClicked as trackEvidenceSaveChatClickedHost,
  trackEvidenceSidebarClicked as trackEvidenceSidebarClickedHost,
  trackEvidenceSourcesListClicked as trackEvidenceSourcesListClickedHost,
  trackEvidenceSourcesListCustomClicked as trackEvidenceSourcesListCustomClickedHost,
  trackEvidenceSourcesListLocalGuidelinesClicked as trackEvidenceSourcesListLocalGuidelinesClickedHost,
  trackEvidenceSourcesListPresetClicked as trackEvidenceSourcesListPresetClickedHost,
  trackEvidenceSourcesListWebSearchClicked as trackEvidenceSourcesListWebSearchClickedHost,
  trackEvidenceSpecialtyChanged as trackEvidenceSpecialtyChangedHost,
  trackEvidenceToastShown as trackEvidenceToastShownHost,
  trackEvidenceToastViewClicked as trackEvidenceToastViewClickedHost,
  trackEvidenceUnsaveChatClicked as trackEvidenceUnsaveChatClickedHost,
} from '@/lib/analytics/scribe/evidence';
import {
  exportContentSaved as exportContentSavedHost,
  exportSettingToggled as exportSettingToggledHost,
} from '@/lib/analytics/scribe/export-settings';
import {
  trackFeedbackModalReasonSelected as trackFeedbackModalReasonSelectedHost,
  trackFeedbackModalSelectedRate as trackFeedbackModalSelectedRateHost,
  trackNoteFeedbackSubmitted as trackNoteFeedbackSubmittedHost,
} from '@/lib/analytics/scribe/feedback';
import {
  trackForceUpdateDeferred as trackForceUpdateDeferredHost,
  trackForceUpdateInitiated as trackForceUpdateInitiatedHost,
  trackForceUpdateViewed as trackForceUpdateViewedHost,
} from '@/lib/analytics/scribe/force-update';
import {
  trackFormFillCreateTemplateClicked as trackFormFillCreateTemplateClickedHost,
  trackFormFillHelpArticleClicked as trackFormFillHelpArticleClickedHost,
  trackFormFillUploadClicked as trackFormFillUploadClickedHost,
  trackFormLibraryViewed as trackFormLibraryViewedHost,
} from '@/lib/analytics/scribe/form-fill';
import {
  gotFirstNonEmptyTranscriptChunk as gotFirstNonEmptyTranscriptChunkHost,
  integrationReadyModalClosed as integrationReadyModalClosedHost,
  markSessionAsContextOnly as markSessionAsContextOnlyHost,
  navigationDiscoveryCall as navigationDiscoveryCallHost,
  navigationFranceCall as navigationFranceCallHost,
  navigationGermanCall as navigationGermanCallHost,
  navigationSpanishCall as navigationSpanishCallHost,
  noteAutoRetryDecided as noteAutoRetryDecidedHost,
  noteGenerationEnd as noteGenerationEndHost,
  noteGenerationError as noteGenerationErrorHost,
  noteGenerationFinished as noteGenerationFinishedHost,
  noteGenerationStart as noteGenerationStartHost,
  saveSettings as saveSettingsHost,
  tauriSessionMismatch as tauriSessionMismatchHost,
  trackBackupSizeZeroError as trackBackupSizeZeroErrorHost,
  trackChunkSessionMismatch as trackChunkSessionMismatchHost,
  trackDefaultDeviceErrorTauri as trackDefaultDeviceErrorTauriHost,
  trackDeleteAccountSuccess as trackDeleteAccountSuccessHost,
  trackFailedToSendChunk as trackFailedToSendChunkHost,
  trackFailedToStartChunkRecording as trackFailedToStartChunkRecordingHost,
  trackGetCurrentRecordingFailed as trackGetCurrentRecordingFailedHost,
  trackMediaRecorderFailedToStart as trackMediaRecorderFailedToStartHost,
  trackMediaRecorderUnableToStop as trackMediaRecorderUnableToStopHost,
  trackMediaStreamChunkTrackStateError as trackMediaStreamChunkTrackStateErrorHost,
  trackRecordingTriesToStartWhenStatusIsRecording as trackRecordingTriesToStartWhenStatusIsRecordingHost,
  trackShortcutUsed as trackShortcutUsedHost,
  trackSnippetCreated as trackSnippetCreatedHost,
  trackSnippetDeleted as trackSnippetDeletedHost,
  trackSnippetEdited as trackSnippetEditedHost,
  trackSnippetOpenPrompt as trackSnippetOpenPromptHost,
  trackSnippetUsed as trackSnippetUsedHost,
  trackToggleUserMfa as trackToggleUserMfaHost,
  trackUseHeidiButtonClicked as trackUseHeidiButtonClickedHost,
} from '@/lib/analytics/scribe/general';
import {
  trackGettingStartedCompleted as trackGettingStartedCompletedHost,
  trackGettingStartedPanelClosed as trackGettingStartedPanelClosedHost,
  trackGettingStartedPanelNextStep as trackGettingStartedPanelNextStepHost,
  trackGettingStartedPanelOpened as trackGettingStartedPanelOpenedHost,
  trackGettingStartedPanelOpenReferralModal as trackGettingStartedPanelOpenReferralModalHost,
  trackOnboardingCompleted as trackOnboardingCompletedHost,
} from '@/lib/analytics/scribe/getting-started';
import {
  trackFindReplaceDocumentEdited as trackFindReplaceDocumentEditedHost,
  trackFindReplaceModalSubmitted as trackFindReplaceModalSubmittedHost,
  trackFindReplaceScopeAllTabsSelected as trackFindReplaceScopeAllTabsSelectedHost,
  trackFindReplaceScopeEverywhereSelected as trackFindReplaceScopeEverywhereSelectedHost,
  trackFindReplaceScopeJustNoteSelected as trackFindReplaceScopeJustNoteSelectedHost,
} from '@/lib/analytics/scribe/global-config';
import {
  trackGlobalTemplateCreated as trackGlobalTemplateCreatedHost,
  trackGlobalTemplateDeleted as trackGlobalTemplateDeletedHost,
  trackGlobalTemplateVisibilityChanged as trackGlobalTemplateVisibilityChangedHost,
} from '@/lib/analytics/scribe/global-template';
import {
  integrationRequest as integrationRequestHost,
  widgetLinkAccountStartTrialClicked as widgetLinkAccountStartTrialClickedHost,
} from '@/lib/analytics/scribe/integration';
import {
  trackConnectIntegration as trackConnectIntegrationHost,
  trackHaikuTabChanged as trackHaikuTabChangedHost,
  trackIntegrationCreated as trackIntegrationCreatedHost,
  trackIntegrationDataFailed as trackIntegrationDataFailedHost,
  trackIntegrationDataRetrieved as trackIntegrationDataRetrievedHost,
  trackIntegrationFailed as trackIntegrationFailedHost,
  trackIntegrationPatientSelected as trackIntegrationPatientSelectedHost,
  trackIntegrationSessionCreated as trackIntegrationSessionCreatedHost,
  trackIntegrationStarted as trackIntegrationStartedHost,
  trackIntegrationWidgetAuthStepCompleted as trackIntegrationWidgetAuthStepCompletedHost,
  trackIntegrationWidgetAuthStepErrored as trackIntegrationWidgetAuthStepErroredHost,
  trackIntegrationWidgetAuthStepMisc as trackIntegrationWidgetAuthStepMiscHost,
  trackNoteSynced as trackNoteSyncedHost,
  trackNoteSyncFailed as trackNoteSyncFailedHost,
  trackTokenGenerated as trackTokenGeneratedHost,
  widgetLinkAccountUnlinkSwitch as widgetLinkAccountUnlinkSwitchHost,
  widgetLinkEhrAccountAlreadyLinkedToHeidi as widgetLinkEhrAccountAlreadyLinkedToHeidiHost,
  widgetLinkHeidiAccountAlreadyLinkedToEhr as widgetLinkHeidiAccountAlreadyLinkedToEhrHost,
} from '@/lib/analytics/scribe/integrations';
import { trackCreatePatientProfile as trackCreatePatientProfileHost } from '@/lib/analytics/scribe/link';
import {
  trackMedicalDirectorGetDemographicsFailed as trackMedicalDirectorGetDemographicsFailedHost,
  trackMedicalDirectorGetPatientSessionsFailed as trackMedicalDirectorGetPatientSessionsFailedHost,
  trackMedicalDirectorSyncSessionsFailed as trackMedicalDirectorSyncSessionsFailedHost,
  userHasMedicalDirector as userHasMedicalDirectorHost,
} from '@/lib/analytics/scribe/medical-director';
import {
  replacementsUploadedV2 as replacementsUploadedV2Host,
  snippetsUploadedV2 as snippetsUploadedV2Host,
  trackBulkUploadReplacements as trackBulkUploadReplacementsHost,
} from '@/lib/analytics/scribe/memory';
import {
  navigationGetStartedFAQ as navigationGetStartedFAQHost,
  navigationHelp as navigationHelpHost,
  navigationRoadmap as navigationRoadmapHost,
} from '@/lib/analytics/scribe/navigation';
import {
  noteGeneratedByAskAI as noteGeneratedByAskAIHost,
  noteGeneratedByPressAICommand as noteGeneratedByPressAICommandHost,
  noteGeneratedByTemplate as noteGeneratedByTemplateHost,
} from '@/lib/analytics/scribe/note';
import {
  trackNoteReverted as trackNoteRevertedHost,
  trackNoteUpdated as trackNoteUpdatedHost,
} from '@/lib/analytics/scribe/notes';
import { trackNotificationPreferencesSavedFromModal as trackNotificationPreferencesSavedFromModalHost } from '@/lib/analytics/scribe/notification';
import {
  trackContextLinked as trackContextLinkedHost,
  trackContextPreviewed as trackContextPreviewedHost,
  trackContextUnlinked as trackContextUnlinkedHost,
} from '@/lib/analytics/scribe/past-context';
import {
  trackPatientContextToggleOff as trackPatientContextToggleOffHost,
  trackPatientContextToggleOn as trackPatientContextToggleOnHost,
  trackPatientExtractionModalOpened as trackPatientExtractionModalOpenedHost,
  trackPatientExtractionReviewed as trackPatientExtractionReviewedHost,
  trackPatientLinked as trackPatientLinkedHost,
  trackPatientSelected as trackPatientSelectedHost,
  trackPatientSummaryCtaShown as trackPatientSummaryCtaShownHost,
  trackPatientSummaryEmailSendAttempted as trackPatientSummaryEmailSendAttemptedHost,
  trackPatientSummaryEmailSent as trackPatientSummaryEmailSentHost,
  trackPatientSummarySmsSendAttempted as trackPatientSummarySmsSendAttemptedHost,
  trackPatientSummarySmsSent as trackPatientSummarySmsSentHost,
  trackPatientUnlinked as trackPatientUnlinkedHost,
  trackPatientUpdated as trackPatientUpdatedHost,
  trackPatientViewed as trackPatientViewedHost,
} from '@/lib/analytics/scribe/patient';
import {
  paywallCheckoutClickedFromFreeToPaid as paywallCheckoutClickedFromFreeToPaidHost,
  paywallModalOpenFromAccountToPro as paywallModalOpenFromAccountToProHost,
  paywallModalOpenFromAskAI as paywallModalOpenFromAskAIHost,
  paywallModalOpenFromExtendProTrial as paywallModalOpenFromExtendProTrialHost,
  paywallModalOpenFromNoTeamMemberPage as paywallModalOpenFromNoTeamMemberPageHost,
  paywallModalOpenFromProActionOnFree as paywallModalOpenFromProActionOnFreeHost,
  paywallModalOpenFromQuotaExceeded as paywallModalOpenFromQuotaExceededHost,
  paywallModalOpenFromSessionHeader as paywallModalOpenFromSessionHeaderHost,
  paywallModalOpenFromSidebar as paywallModalOpenFromSidebarHost,
  paywallModalOpenFromVisibilityToTeam as paywallModalOpenFromVisibilityToTeamHost,
  trackPaywallViewed as trackPaywallViewedHost,
} from '@/lib/analytics/scribe/payments';
import { paywallCheckoutClickedFromUpgrade as paywallCheckoutClickedFromUpgradeHost } from '@/lib/analytics/scribe/paywall';
import {
  trackPersonalizationTurnedOff as trackPersonalizationTurnedOffHost,
  trackPersonalizationTurnedOn as trackPersonalizationTurnedOnHost,
} from '@/lib/analytics/scribe/personalization';
import { trackPyneOnboardingRendered as trackPyneOnboardingRenderedHost } from '@/lib/analytics/scribe/pyne';
import {
  trackReferralLinkCopied as trackReferralLinkCopiedHost,
  trackReferralLinkCreated as trackReferralLinkCreatedHost,
  trackReferralModalOpened as trackReferralModalOpenedHost,
} from '@/lib/analytics/scribe/referral';
import { trackScribeStyleUpdated as trackScribeStyleUpdatedHost } from '@/lib/analytics/scribe/scribe';
import { sectionalNoteEhrSectionSelected as sectionalNoteEhrSectionSelectedHost } from '@/lib/analytics/scribe/sectional-note';
import {
  chooseDictation as chooseDictationHost,
  chooseTranscribe as chooseTranscribeHost,
  reachedAudioLevelDuringRecording as reachedAudioLevelDuringRecordingHost,
  selectLanguage as selectLanguageHost,
  sessionAllDeleted as sessionAllDeletedHost,
  sessionChooseMicInput as sessionChooseMicInputHost,
  sessionCopyClicked as sessionCopyClickedHost,
  sessionCreated as sessionCreatedHost,
  sessionDateTimeUpdated as sessionDateTimeUpdatedHost,
  sessionDeleteByIds as sessionDeleteByIdsHost,
  sessionPauseRecording as sessionPauseRecordingHost,
  sessionResumeRecording as sessionResumeRecordingHost,
  sessionStartRecording as sessionStartRecordingHost,
  sessionStopRecording as sessionStopRecordingHost,
  sessionTemplateUpdated as sessionTemplateUpdatedHost,
  sessionViewed as sessionViewedHost,
  sessionVoiceUpdated as sessionVoiceUpdatedHost,
  uploadRecordingCancelled as uploadRecordingCancelledHost,
  uploadRecordingFailed as uploadRecordingFailedHost,
  uploadRecording as uploadRecordingHost,
  uploadRecordingSuccess as uploadRecordingSuccessHost,
} from '@/lib/analytics/scribe/session';
import { copySettingsUpdated as copySettingsUpdatedHost } from '@/lib/analytics/scribe/sessions';
import {
  trackUserSettingsDateFormatChanged as trackUserSettingsDateFormatChangedHost,
  trackUserSettingsSpellingPreferenceChanged as trackUserSettingsSpellingPreferenceChangedHost,
  trackUserSettingsWordLibraryAdded as trackUserSettingsWordLibraryAddedHost,
} from '@/lib/analytics/scribe/settings';
import {
  signUpFlowStarted as signUpFlowStartedHost,
  signUpPhoneNumberChanged as signUpPhoneNumberChangedHost,
  trackSignUpFormCompleted as trackSignUpFormCompletedHost,
  trackSignupSuccessful as trackSignupSuccessfulHost,
} from '@/lib/analytics/scribe/sign-up';
import {
  trackOrganisationSurveyEhrProviderSelected as trackOrganisationSurveyEhrProviderSelectedHost,
  trackOrganisationSurveyNameEntered as trackOrganisationSurveyNameEnteredHost,
  trackOrganisationSurveyRoleSelected as trackOrganisationSurveyRoleSelectedHost,
  trackOrganisationSurveyShown as trackOrganisationSurveyShownHost,
  trackOrganisationSurveySizeSelected as trackOrganisationSurveySizeSelectedHost,
  trackOrganisationSurveySubmitted as trackOrganisationSurveySubmittedHost,
} from '@/lib/analytics/scribe/survey';
import {
  trackTabSharingDoNoShowMessageAgain as trackTabSharingDoNoShowMessageAgainHost,
  trackTabSharingNotAvailableModalShown as trackTabSharingNotAvailableModalShownHost,
} from '@/lib/analytics/scribe/tab';
import {
  trackClinicalTaskPanelToggle as trackClinicalTaskPanelToggleHost,
  trackTaskEvent as trackTaskEventHost,
  trackTaskListViewedEvent as trackTaskListViewedEventHost,
  trackTaskNotificationClickedEvent as trackTaskNotificationClickedEventHost,
  trackTaskStatefulEvent as trackTaskStatefulEventHost,
  trackTaskViewedEvent as trackTaskViewedEventHost,
} from '@/lib/analytics/scribe/task';
import {
  trackTauriFailedToRelaunch as trackTauriFailedToRelaunchHost,
  trackTauriRelaunch as trackTauriRelaunchHost,
  trackTauriStopFailedSurfaced as trackTauriStopFailedSurfacedHost,
  trackTauriStopRecordingPreventedAsRecordingStillInitializing as trackTauriStopRecordingPreventedAsRecordingStillInitializingHost,
  trackTauriUpdate as trackTauriUpdateHost,
} from '@/lib/analytics/scribe/tauri';
import {
  trackAcceptTeamInvitation as trackAcceptTeamInvitationHost,
  trackDeleteTeam as trackDeleteTeamHost,
  trackDeleteTeamMember as trackDeleteTeamMemberHost,
  trackResendTeamInvitation as trackResendTeamInvitationHost,
  trackSelfOnboardingClicked as trackSelfOnboardingClickedHost,
  trackTeamBillingClicked as trackTeamBillingClickedHost,
  trackTeamCreate as trackTeamCreateHost,
  trackTeamEvidenceAccessUpdated as trackTeamEvidenceAccessUpdatedHost,
  trackTeamHeidiIiAccessUpdated as trackTeamHeidiIiAccessUpdatedHost,
  trackTeamMemberGuideVideoButtonClicked as trackTeamMemberGuideVideoButtonClickedHost,
  trackTeamUpdated as trackTeamUpdatedHost,
  trackToggleTeamConsent as trackToggleTeamConsentHost,
  trackToggleTeamMfa as trackToggleTeamMfaHost,
  trackUpdateSpecialtyClicked as trackUpdateSpecialtyClickedHost,
  trackUpdateTeamCustomConsentText as trackUpdateTeamCustomConsentTextHost,
  trackUserJoinTeamSuccess as trackUserJoinTeamSuccessHost,
} from '@/lib/analytics/scribe/team';
import {
  templateCreateAskAi as templateCreateAskAiHost,
  trackPDFTemplateCreated as trackPDFTemplateCreatedHost,
  trackTemplateDeleted as trackTemplateDeletedHost,
  trackTemplateEdited as trackTemplateEditedHost,
  trackTemplateEditorUpdated as trackTemplateEditorUpdatedHost,
  trackTemplateFavourited as trackTemplateFavouritedHost,
  trackTemplateGeneration as trackTemplateGenerationHost,
  trackTemplateLibraryFilteredApplied as trackTemplateLibraryFilteredAppliedHost,
  trackTemplateLibrarySearched as trackTemplateLibrarySearchedHost,
  trackTemplateLibrarySortApplied as trackTemplateLibrarySortAppliedHost,
  trackTemplateLibraryViewed as trackTemplateLibraryViewedHost,
  trackTemplateOpened as trackTemplateOpenedHost,
  trackTemplateUpdated as trackTemplateUpdatedHost,
} from '@/lib/analytics/scribe/template';
import {
  trackTemplateCreated as trackTemplateCreatedHost,
  trackTemplateCreationRecordCreated as trackTemplateCreationRecordCreatedHost,
  trackTemplatePinned as trackTemplatePinnedHost,
} from '@/lib/analytics/scribe/templates';
import {
  endTrialModalClosed as endTrialModalClosedHost,
  endTrialModalDowngradeClicked as endTrialModalDowngradeClickedHost,
  endTrialModalOpened as endTrialModalOpenedHost,
  endTrialModalPeriodChanged as endTrialModalPeriodChangedHost,
  endTrialModalUpgradeClicked as endTrialModalUpgradeClickedHost,
  extendTrialModalBackClicked as extendTrialModalBackClickedHost,
  extendTrialModalExtendClicked as extendTrialModalExtendClickedHost,
  extendTrialModalOpened as extendTrialModalOpenedHost,
  settingsBillingCurrentPlanUpgradeClicked as settingsBillingCurrentPlanUpgradeClickedHost,
  settingsBillingEnterpriseGetInTouchClicked as settingsBillingEnterpriseGetInTouchClickedHost,
  settingsBillingTrialUpgradeNowClick as settingsBillingTrialUpgradeNowClickHost,
  settingsManageBillingClicked as settingsManageBillingClickedHost,
  settingsTrialBillingCancelTrialClick as settingsTrialBillingCancelTrialClickHost,
  templateCreateNewClicked as templateCreateNewClickedHost,
  templateCreateUseExistingClicked as templateCreateUseExistingClickedHost,
  templateCreateUseScratchClicked as templateCreateUseScratchClickedHost,
  trackCreateNoteOrDocumentClicked as trackCreateNoteOrDocumentClickedHost,
  trackFieldSelected as trackFieldSelectedHost,
  trackFindReplaceModalCancelled as trackFindReplaceModalCancelledHost,
  trackFindReplaceModalOpened as trackFindReplaceModalOpenedHost,
  trackModalViewed as trackModalViewedHost,
  trackScreenViewed as trackScreenViewedHost,
  trackSendTeamInvitation as trackSendTeamInvitationHost,
  trialToPaidModalClosed as trialToPaidModalClosedHost,
  trialToPaidModalOpened as trialToPaidModalOpenedHost,
  trialToPaidModalPeriodChanged as trialToPaidModalPeriodChangedHost,
  trialToPaidModalUpgradeClicked as trialToPaidModalUpgradeClickedHost,
} from '@/lib/analytics/scribe/ui';
import { trackVoiceStyleUpdated as trackVoiceStyleUpdatedHost } from '@/lib/analytics/scribe/voice';
import { isSnowplowSuppressedEvent } from '@/lib/analytics/snowplow-suppression';
import { trackLegacyEvent } from '@/lib/analytics/track-legacy-event';
import { trackV2, type TrackV2Event } from '@/lib/analytics/track-v2';
import {
  DESKTOP_NATIVE_PLATFORM_SOURCE,
  formatRemoteConfigOsVersion,
  formatRemoteConfigRegion,
  setRemoteConfigCustomSignals,
} from '@/lib/firebase/custom-signals';
import { setSnowplowUserContext, setSnowplowUserId } from '@/lib/snowplow';
import { type ClinicianTypeInput } from '@/lib/types';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import { type RecordingStopFailedPath } from '@/models/analytics/features/audio';
import {
  type BookDemoCliniciansSelectedEventProps,
  type BookDemoCountrySelectedEventProps,
  type BookDemoFormSubmittedEventProps,
  type BookDemoNextClickedEventProps,
} from '@/models/analytics/features/book-demo';
import {
  type ChatCreatedEventProps,
  type ChatDeletedEventProps,
  type ChatViewedEventProps,
} from '@/models/analytics/features/chat';
import {
  type NHSAskHeidiComplianceDetailedProps,
  type NHSTemplateComplianceDetailedProps,
} from '@/models/analytics/features/compliance';
import type { ContactSalesFormOpenedEventProps } from '@/models/analytics/features/contact-sales';
import {
  type DictationCompletedEventProps,
  type DictationCsatDismissedEventProps,
  type DictationCsatSubmittedEventProps,
  type DictationErroredEventProps,
  type DictationStartedEventProps,
  type LegacyInlineDictationCompletedEventProps,
} from '@/models/analytics/features/dictation';
import {
  type DocumentEventProps,
  type DocumentExportContext,
  type DocumentExportedEventProps,
  type DocumentTemplateQueueLimitReachedEventProps,
  type DocumentTemplateQueueReorderedEventProps,
  type QueuedDocumentGenerationCancelledEventProps,
  type QueuedDocumentGenerationFailedEventProps,
  type QueuedDocumentGenerationStartedEventProps,
  type QueuedDocumentTabTemplateSwappedEventProps,
  type SessionStartedWithDocumentQueueEventProps,
  type SettingsPipeline,
} from '@/models/analytics/features/documents';
import type { DesktopCaptureOriginProp } from '@/models/analytics/features/errors';
import {
  type EvidenceChatAbortedEventProps,
  type EvidenceChatCompletedEventProps,
  type EvidenceChatErrorEventProps,
  type EvidenceChatSidebarCloseEventProps,
  type EvidenceChatSidebarOpenEventProps,
  type EvidenceChatSubmittedEventProps,
  type EvidenceClickPastSessionClickedEventProps,
  type EvidenceDeepLinkSignInClickedEventProps,
  type EvidenceDeepLinkSignUpClickedEventProps,
  type EvidenceDeleteChatClickedEventProps,
  type EvidenceJurisdictionChangedEventProps,
  type EvidenceLanguageChangedEventProps,
  type EvidenceLocation,
  type EvidenceNewChatClickedEventProps,
  type EvidenceNhsContactSalesSubmittedEventProps,
  type EvidenceOnboardingSavedEventProps,
  type EvidenceOnboardingViewedEventProps,
  type EvidenceProTrialButtonStartedEventProps,
  type EvidenceSaveChatClickedEventProps,
  type EvidenceSharedChatOpenedEventProps,
  type EvidenceShareLinkCopiedEventProps,
  type EvidenceShareModalOpenedEventProps,
  type EvidenceShareSocialClickedEventProps,
  type EvidenceShareSocialPlatform,
  type EvidenceSidebarClickedEventProps,
  type EvidenceSourceSelectionMode,
  type EvidenceSourcesListClickedEventProps,
  type EvidenceSourcesListCustomClickedEventProps,
  type EvidenceSourcesListLocalGuidelinesClickedEventProps,
  type EvidenceSourcesListPresetClickedEventProps,
  type EvidenceSourcesListWebSearchClickedEventProps,
  type EvidenceSpecialtyChangedEventProps,
  type EvidenceToastShownEventProps,
  type EvidenceToastViewClickedEventProps,
  type EvidenceUnsaveChatClickedEventProps,
} from '@/models/analytics/features/evidence';
import {
  type ExportContentSavedEventProps,
  type ExportSettingScope,
  type ExportSettingType,
} from '@/models/analytics/features/export-settings';
import {
  type ForceUpdateDeferredEventProps,
  type ForceUpdateInitiatedEventProps,
  type ForceUpdateViewedEventProps,
} from '@/models/analytics/features/forceUpdate';
import {
  type HaikuTabChangedEventProps,
  type IntegrationCreatedEventProps,
  type IntegrationDataCompletedEventProps,
  type IntegrationDataFailedEventProps,
  type IntegrationDataRetrievedEventProps,
  type IntegrationFailedEventProps,
  type IntegrationNoteSyncedEventProps,
  type IntegrationPatientSelectedEventProps,
  type IntegrationSessionCreatedEventProps,
  type IntegrationStartedEventProps,
  type IntegrationType,
  type IntegrationUpdatedEventProps,
  type IntegrationUserSearchedEventProps,
  type IntegrationWidgetAuthStepCompletedEventProps,
  type IntegrationWidgetAuthStepErroredEventProps,
  type IntegrationWidgetAuthStepMiscEventProps,
  type PatientSearchedEventProps,
  type TokenGeneratedEventProps,
} from '@/models/analytics/features/integrations';
import { type UploadSource } from '@/models/analytics/features/memory';
import {
  type NoteEditorType,
  type NoteInsertAction,
  type NoteInsertEditorVariant,
  type NoteRevertedEventProps,
  type NoteUpdateSource,
  type NoteUpdateType,
} from '@/models/analytics/features/notes';
import {
  AuthenticationFlow,
  type AuthenticationProvider,
} from '@/models/analytics/features/onboarding';
import {
  type ContextLinkedEventProps,
  type ContextPreviewedEventProps,
  type ContextUnlinkedEventProps,
} from '@/models/analytics/features/past-context';
import {
  type PatientContextToggleOffEventProps,
  type PatientContextToggleOnEventProps,
  type PatientExtractionModalOpenedEventProps,
  type PatientExtractionReviewedEventProps,
  type PatientLinkedEventProps,
  type PatientRecapSourceSessionClickedEventProps,
  type PatientSelectedEventProps,
  type PatientSummaryCtaShownEventProps,
  type PatientSummaryEmailSendAttemptedEventProps,
  type PatientSummaryEmailSentEventProps,
  type PatientSummarySmsSendAttemptedEventProps,
  type PatientSummarySmsSentEventProps,
  type PatientUnlinkedEventProps,
  type PatientUpdatedEventProps,
  type PatientViewedEventProps,
} from '@/models/analytics/features/patient';
import { type PaywallSource } from '@/models/analytics/features/payments';
import type {
  TeamEvidenceAccessUpdatedEventProps,
  TeamHeidiIiAccessUpdatedEventProps,
} from '@/models/analytics/features/team';
import {
  type RequestMethod,
  type TemplateCreationSource,
  type TemplateQueueSource,
} from '@/models/analytics/features/templates';
import type {
  ButtonEventProps,
  ScreenEventProps,
  TeamInviteSource,
} from '@/models/analytics/features/ui';
import {
  type AuthType,
  buildAuthenticationClickedProps,
  mapAuthProviderToProvider,
  mapSignInMethodToAuthType,
  type SessionPageV2EnrollmentSource,
  type SignInMethod,
  SignOutLocation,
} from '@/models/analytics/features/user';
import {
  SegmentActionName,
  SegmentEvidenceActionName,
  SegmentObjectName,
  ShortcutContext,
  TaskEventType,
} from '@/models/analytics/segment-names';
import { type AuthProvider } from '@/models/authModel';
import '@/pages/api/scribeAPI';
import { store } from '@/store';
import { resolveUpdateChannel, type UpdateChannel } from '@/tauri/updater/channel';
import { isTauri } from '@/tauri/utils';
import {
  type AppType,
  type CreateEHRProfileRequest,
  type FeedbackEventTrackBaseProps,
  type FeedbackRequest,
  type FeedbackTags,
  type IntegrationRequest,
  type Maybe,
  type RoleModel,
  type SeenModals,
  type UserRole,
  type WordLibrary,
} from '@/types';
import {
  type DISTRIBUTION_CHANNEL,
  type TAURI_INSTALLER_TYPE,
} from '@/utils/appConfiguration';
import {
  getAppVersionTraits,
  getBuildIdTraits,
  getDesktopVersion,
} from '@/utils/appVersion';
import { AUTH_PROVIDER_COOKIE } from '@/utils/auth/authProviderCookie';
import { isSaasTelemetryEnabled } from '@/utils/buildProfile';
import { deferTelemetryInit } from '@/utils/deferredTelemetry';
import { getDesktopOsVersion } from '@/utils/desktopOsInfo';
import { setSignInMethod } from '@/utils/signInSessionTracking';
import {
  getAttributionIdentifyTraits,
  getLandingUrl,
  getUtmParams,
} from '@/utils/utmTracking';
import * as amplitude from '@amplitude/analytics-browser';
import { Identify as AmplitudeIdentify } from '@amplitude/analytics-browser';
import { datadogRum } from '@datadog/browser-rum';
import { extractExpFromAccessToken } from '@heidi/auth/tokens';
import { type AudioStatus } from '@heidi/capture/useAudioGraphStore/AudioLevelMonitor';
import { type CodeSystem } from '@heidi/coding/contracts';
import { type Period } from '@heidi/commerce/contracts';
import { getAnalyticsContext, registerAnalyticsAdapter } from '@heidi/runtime/analytics';
import {
  ButtonAction,
  type FieldType,
  ScreenName,
} from '@heidi/runtime/analytics-vocabulary';
import {
  type Brain,
  type CodedClinicalEntityRelevance,
  type CSATRating,
  type DateFormat,
  type EHRProvider,
  type GenerationMethod,
  type LanguageCode,
  type OrganisationRole,
  type OrganisationSize,
  type Region,
  type SpellingPreference,
  type SubscriptionTier,
  type TemplateAuthorGroup,
  type TemplateCategory,
  type TemplateVisibility,
  type VoiceStyle,
} from '@heidi/schema/ml-scribe';
import {
  type CustomStyle,
  type SessionResponse,
  type SessionUpdate,
} from '@heidi/session/contracts';
import { type ClinicalTask, type ClinicalTaskCategory } from '@heidi/tasks/contracts';
import { type TeamModel, type UpdateUserRequest } from '@heidi/workspace/contracts';
import { createModel } from '@rematch/core';
import { getCookie } from 'cookies-next/client';
import Router from 'next/router';
import posthog from 'posthog-js';
import type { RootModel } from '.';
import { type NoteFailedErrorCode } from './analytics/contracts/note-failed-error-code';
import { type AssistantPanelActionEventProps } from './analytics/features/assistant-view';
import {
  type AudioWarningEventProps,
  type CaptureMode,
  type InputDefaultKind,
} from './analytics/features/audio';
import {
  type CopyMethod,
  type CopySetting,
  type CopySettingsSnapshot,
  type SessionCopiedFormat,
  type SessionCopySource,
} from './analytics/features/sessions';

/** Extract ValidPropertyType from Amplitude's Identify.set() method signature */
type AmplitudePropertyType = Parameters<AmplitudeIdentify['set']>[1];

/**
 * Input shape for `analyticsScribe.trackButtonClicked`.
 *
 * Tightens `ButtonEventProps` (where `screen_name` and `action` are
 * declared optional) so that every dispatch through the helper carries
 * both — neither the snake_case nor the legacy camelCase arm can be
 * called with just a `label`. See helper JSDoc for the policy.
 */
export type TrackButtonClickedInput =
  | (ButtonEventProps & {
      screen_name: ScreenName;
      action: ButtonAction;
      /** @deprecated Pass `screen_name` directly. */
      screenName?: ScreenName;
      /** @deprecated Pass `task_id` directly. */
      taskId?: string;
      /** @deprecated Pass `click_source` directly. */
      clickSource?: string;
    })
  | (ButtonEventProps & {
      /** @deprecated Pass `screen_name` directly. */
      screenName: ScreenName;
      action: ButtonAction;
      /** @deprecated Pass `task_id` directly. */
      taskId?: string;
      /** @deprecated Pass `click_source` directly. */
      clickSource?: string;
    });

export type TrackingProps = {
  action: string;
  eventName?: string;
  sessionId?: string;
  documentId?: string;
  microphone?: string;
  userDetail?: string;
  aiCommandText?: string;
  aiCommandId?: string;
  presetCommandId?: string;
  existingTemplate?: string;
  specialtyId?: string;
  specialtyName?: string;
  otherSpecialty?: string;
  settingsUpdatedData?: UpdateUserRequest;
  templateId?: string;
  templateType?: TemplateVisibility;
  templateName?: string;
  templateContent?: string;
  templatePinned?: boolean;
  templateFavourited?: boolean;
  questionAskedLength?: number;
  paymentPeriod?: Period;
  language?: LanguageCode;
  multipleLanguages?: LanguageCode[];
  fileSize?: number;
  error?: string;
  errorDescription?: string;
  generationMethod?: GenerationMethod;
  voiceStyle?: VoiceStyle;
  oldVoiceStyle?: VoiceStyle;
  sentDocumentEmail?: string;
  createdTimeLocal?: string;
  integrationRequest?: IntegrationRequest;
  transcribeMode?: SessionResponse['transcribe_mode'];
  duration?: number;
  outputLanguage?: SessionUpdate['language_code'];
  searchQuery?: string;
  filter?: string;
  sort?: string;
  // for demo tour
  device?: 'DESKTOP' | 'MOBILE';
  selectedSoftware?: EHRProvider;
  siteId?: string;
  guId?: string;
  firstName?: string;
  lastName?: string;
  userId?: string;
  userInfo?: CreateEHRProfileRequest;
  date?: Date;
  teamName?: string;
  teamId?: string;
  invitedEmail?: string;
  invitationId?: string;
  memberId?: string;
  joinTeamMethod?: string;
  teamLink?: string;
  memberEmail?: string;
  referralId?: string;
  couponId?: string;
  organisationSize?: OrganisationSize;
  organisationRole?: OrganisationRole;
  organisationName?: string;
  ehrProvider?: string;
  withSdes?: boolean;
  heidiSectionTitle?: string;
  ehrSectionTitle?: string;
  isUnlinking?: boolean;
  custom_utm_source?: string | null;
  deeplink_utm_source?: string | null;
  deeplink_utm_medium?: string | null;
  deeplink_utm_campaign?: string | null;
  baa_required?: boolean;
  compliance_kit_required?: boolean;
  phone_number_provided?: boolean;
  reason?: string;
  // sign in
  sign_in_method?: 'email' | 'google' | 'microsoft' | 'apple';
  // chat
  mode?: string;
  previous_mode?: string;
  new_mode?: string;
  query?: string;
  message_length?: number;
  // feedback
  details?: string;
  documentName?: string;
  rating?: CSATRating;
  noteCategory?: TemplateCategory | TabType;
  noteId?: string;
  feedbackTags?: FeedbackTags;
  feedbackDetail?: string;
  timestamp?: string;
  feedbackCategory?: TabType;
  // paywall
  target_plan?: SubscriptionTier;
  paywall_context?: SegmentContext | null;
  enabled?: boolean;
  adminId?: string;
  hasCustomText?: boolean;
  // global config
  dateFormat?: DateFormat;
  spellingPreference?: SpellingPreference;
  wordLibrary?: WordLibrary;

  isRecordingV2Enabled?: boolean;
  isTabSharing?: boolean;
  transcriptionServiceVersion?: 'v1' | 'v2';

  // template community
  search?: string;
  templateVisibility?: TemplateVisibility;
  formFilling?: boolean;

  // form filling document generation
  requestTime?: string;
  responseTime?: string;
  status?: 'success' | 'failed';
  failedReason?: string;

  // context tab
  wordCount?: number;

  // template chat builder
  creationType?: 'chat' | 'existing_template' | 'upload';
  numberOfUploads?: number;
  hasSuggestions?: boolean;
  editType?: 'inline' | 'chat' | 'suggestion';
  hasDictation?: boolean;
  confirmed?: boolean;

  // export header/footer settings
  has_logo?: boolean;
  has_text?: boolean;
  signature_type?: 'image' | 'text' | null;
  position?: 'left' | 'center' | 'right';

  // snippets
  snippetId?: string;
  contentLength?: number;
  shorthandLength?: number;
  from?: string;
  snippets?: {
    shorthand: string;
    content: string;
    verbal_trigger?: string;
  }[];
  snippetCount?: number;

  // replacements
  replacementId?: string;
  findLength?: number;
  replaceLength?: number;
  count?: number;

  // shortcuts
  shortcutName?: string;

  // link sessions to patient profile
  sessionIds?: string[];
  patientId?: string;
  numberOfSessions?: number;
  isFromEHR?: boolean;

  // integrations
  profile_name?: string;

  // notifications
  isInmailNotificationEnabled?: boolean;
  isSessionExpiringNotificationEnabled?: boolean;
  isNotificationPreferencesSavedFromSettingsPage?: boolean;
  isNotificationPreferencesSavedFromModal?: boolean;

  // speaker size — the one dispatcher reads them off `inspect_*_file()`, which
  // returns bytes, so both have always arrived as numbers.
  speakerSize?: number | string;
  audioSize?: number | string;
  version?: string;

  step?: string;

  size?: number | string;
  numberFilesDeleted?: number;

  // streaming
  noteGenerationStartTime?: number;
  noteGenerationEndTime?: number;

  totalDuration?: number;
  durationBeforeWaitingUpload?: number;
  durationWaitingToUpload?: number;
  durationWaitingToStream?: number;
  durationStreaming?: number;
  durationCompletingStreaming?: number;

  index?: number;

  location?:
    | 'cta-button'
    | 'account-form'
    | 'quota-reminder'
    | 'banner'
    | 'notification'
    | 'settings'
    | 'end-trial-modal'
    | 'one-day-reminder';
  period?: Period;
  selectHours?: number;
  isSuccess?: boolean;

  recordingId?: string | number;
  chunkId?: string | number;
  chunkCount?: number;
  currentSessionId?: string;
  newSessionId?: string;

  // customise template menu
  customStyle?: CustomStyle;
  oldCustomStyle?: CustomStyle;
  transitionType?: string;
  brain?: Brain;
  voice?: VoiceStyle;
  quotaExceeded?: boolean;
  inputDevice?: string;
  inputDeviceId?: string;

  // task related
  taskId?: string;
  taskTimeToCompletion?: number;
  taskCategory?: ClinicalTaskCategory;
  taskSource?: string;
  taskEdits?: TaskEdit[];
  audioLevel?: AudioStatus;

  // coding sidebar
  codesetsEnabled?: string[];
  totalCodesAvailable?: number;
  kindeUserId?: string;

  //pyne
  region?: string;

  // phone number tracking
  country?: string;
  phoneNumber?: string;

  // citation tracking
  citationUrl?: string;
  citationTitle?: string;
  citationSource?: 'response' | 'sources';
  // global template
  previousVisibility?: TemplateVisibility;
  visibility?: TemplateVisibility;
  sharedTeams?: string[];
  changedBy?: OrganizationTemplateChangedBy;
  usedFor?: OrganizationTemplateUsedFor;
  // feedback tracking
  feedbackType?: 'positive' | 'negative';

  // template tracking
  is_pinned_template?: boolean;
  is_starter_pack_template?: boolean;

  // share-via-email merged modal (release-scribe-send-as-email-merged-modal)
  recipient_count?: number;
  included_link?: boolean;
  link_scope?: string;
  link_ttl?: string;
  partial_failure?: boolean;

  // evidence tracking
  evidence_location?: EvidenceLocation;
  is_evidence_pro?: boolean;
  is_team_member?: boolean;
  query_length?: number;
  sources_count?: number;
  sources?: string[];
  selection_mode?: EvidenceSourceSelectionMode;
  preset_primary_evidence?: boolean;
  preset_local_guidelines?: boolean;
  preset_web_search?: boolean;
  chat_id?: string;
  session_id?: string;
  duration_ms?: number;
  time_to_first_token_ms?: number;
  references_count?: number;
  error_message?: string;
  error_code?: string;
  // desktop IPC error event (trackTauriErrorEvent)
  capture_origin?: DesktopCaptureOriginProp;
  preset_type?: 'primary_evidence' | 'local_guidelines' | 'web_search';
  is_enabled?: boolean;
  custom_sources_count?: number;
  click_source?: 'sidebar' | 'header' | 'history_overlay';
  subscription_period?: 'monthly' | 'yearly';
  subscription_tier?: string;
  language_code?: string;
  specialty_id?: string;

  // export header/footer tracking
  has_custom_header?: boolean;
  has_custom_footer?: boolean;
  has_signature?: boolean;
  // evidence onboarding
  has_existing_specialty?: boolean;
  has_existing_jurisdiction?: boolean;
  jurisdiction?: string;
  jurisdiction_code?: string;
  specialty_changed?: boolean;
  jurisdiction_changed?: boolean;

  // share evidence chat
  platform?: EvidenceShareSocialPlatform;
  share_token?: string;
  is_authenticated?: boolean;

  // integration user searched
  integration_type?: string;
  guid?: string;
  first_name?: string;
  last_name?: string;
};

// The v1 object/action taxonomy now lives in `./analytics/segment-names`, so a
// call site can name a legacy event without importing this model. Re-exported
// for the importers that already read them from here. `ShortcutContext`,
// `SegmentEvidenceActionName` and `TaskEventType` moved for the same reason
// and are re-exported on the same terms.
export {
  SegmentActionName,
  SegmentEvidenceActionName,
  SegmentObjectName,
  ShortcutContext,
  TaskEventType,
};

// The v1 sender's Segment facade and ambient traits now live in
// `@/lib/analytics/legacy-sender-context`, so an emit host with a v1 leg no
// longer imports this model. Re-exported for the importers that already read
// them from here.
export {
  getAppType,
  getInstallSourceAnalyticsTraits,
  getPlatform,
  getScreenDimensions,
  segmentClient,
};

enum SegmentContext {
  // paywall context
  PRO_ACTION_ON_FREE = 'pro_action_on_free',
  FREE_USER_EXTEND_PRO_TRIAL = 'free_user_extend_pro_trial',
  INTEGRATION = 'integration',
  TEMPLATE_VISIBILITY_TO_TEAM = 'template_visibility_to_team',
  ASK_AI_INPUT = 'ask_ai_input',
  NOTE_GEN_QUOTA_EXCEEDED = 'note_gen_quota_exceeded',
  ACCOUNT_PROFILE_TO_PRO = 'account_profile_to_pro',
  ACCOUNT_PROFILE_TO_PRACTICE = 'account_profile_to_practice',
  OPEN_ON_SESSION_HEADER = 'session_header',
  OPEN_ON_SIDEBAR = 'sidebar',
  OEPN_ON_NO_TEAM_MEMBER_PAGE = 'no_team_member_page',
}

export interface CommonTraits {
  email: string;
  email_domain?: string;
  App: AppType;
  // Device/build dimensions — optional on identify because they are NOT user
  // identity (they ride per-event via trackEventV2/trackEvent). Kept in the type
  // for any legacy reader; the identify payload no longer sets them.
  app_type?: AppType;
  client_platform?: AppType;
  platform?: 'web' | 'desktop' | 'ios' | 'android';
  installer_type?: TAURI_INSTALLER_TYPE;
  distribution_channel?: DISTRIBUTION_CHANNEL;
  mdm_provider?: string | null;
  cpuArch?: string;
  country?: Maybe<string>;
  region?: Maybe<Region>;
  given_name?: Maybe<string>;
  family_name?: Maybe<string>;
  phone_number?: Maybe<string>;
  has_phone_number?: boolean;
  user_team_id?: Maybe<string>;
  user_team_name?: Maybe<string>;
  user_team_role?: Maybe<UserRole>;
  user_team_plan?: Maybe<string>;
  user_team_mfa_enabled?: Maybe<boolean>;
  user_joined_team_date?: Maybe<string>;
  user_created_date?: Maybe<string>;
  user_tier?: Maybe<SubscriptionTier>;
  team_tier?: Maybe<SubscriptionTier>;
  effective_tier?: Maybe<SubscriptionTier>;
  ehr_provider?: Maybe<EHRProvider>;
  has_integration?: Maybe<boolean>;
  integration_onboarding_provider?: Maybe<EHRProvider>;
  integration_onboarding_created_at?: Maybe<string>;
  integration_onboarding_updated_at?: Maybe<string>;
  source?: Maybe<string>;
  integration_requests?: Maybe<IntegrationRequest[]>;
  mfa_enabled?: boolean;
  mfa_trigger_source?: string;
  opted_in_experimental?: boolean;
  session_page_v2_enrollment_source?: SessionPageV2EnrollmentSource;
  desktop_version?: string;
  // `app_version` (added 2026-05-11 alongside APP-4897): cross-platform
  // app-version field. Today only desktop populates it; web/mobile should
  // backfill so dashboards can break down by `client_platform`+`app_version`
  // instead of `desktop_version` / `ios_version` / etc. Keep `desktop_version`
  // for backward compatibility with existing dashboards and PostHog flag
  // release conditions until they're migrated.
  app_version?: string;
  go_live_time_stamp?: Maybe<string>;
  onboarding_free_text?: Maybe<string>;
  other_specialty?: Maybe<string>;
  display_language?: Maybe<LanguageCode>;
  team_info: {
    team_name?: Maybe<string>;
    team_id?: Maybe<string>;
    user_team_plan?: Maybe<string>;
    user_joined_team_date?: Maybe<string>;
  };
  specialty?: Maybe<string>;
  localised_specialty?: Maybe<string>;
  specialty_group?: Maybe<string>;
  user_role_list?: Maybe<
    {
      id: string;
      name: string;
      config: RoleModel['config'];
    }[]
  >;
  from?: Maybe<string>;
  pathname?: Maybe<string>;
  evidence_access?: Maybe<string>;
  is_evidence_activated?: Maybe<boolean>;
  is_managed?: Maybe<boolean>;
}

// Tasks
export type TaskEdit =
  | {
      field: 'title';
      changed: true;
    }
  | {
      field: 'category' | 'status';
      previous: string;
      next: string;
    };

export type LiveAuthSignal = 'live_token' | 'cookie' | 'none';

/**
 * Which signal (if any) establishes a LIVE auth session — not merely
 * leftover credentials. Decides the Braze gate below ('none' → suppress)
 * and tags the mint-risk telemetry.
 *
 * The original LCM-472 check (`provider cookie || store token`) treated any
 * persisted auth artifact as a session. Both artifacts outlive real
 * sessions: `auth` is redux-persist-whitelisted (a dead token survives
 * until an explicit logout clears it) and the provider cookie's persistent
 * variant lives 30 days. Browsers whose session lapsed WITHOUT a logout
 * (so `resetIdentity` never ran and their stale `ajs_user_id` is intact)
 * therefore passed the check — Braze kept loading on their logged-out
 * pages and the anonymous-profile influx continued.
 *
 * Rule: when a token exists, its JWT `exp` decides — expired or
 * undecodable means NO session, with no cookie fallback (a lapsed
 * web/desktop browser holds BOTH stale artifacts, so any fallback reopens
 * the hole). The cookie fallback covers only tokenless states: most
 * FHIR/EHR/widget launches DO dispatch a store JWT (haiku, sgimed,
 * medtech, widget-auth) and are decided by the exp branch like everyone
 * else — the fallback is for any flow or boot moment where only the
 * provider cookie exists. A stale cookie-without-token combination is
 * rare by construction (explicit logout deletes the cookie; a lapse
 * leaves the token behind, so the exp branch decides false) — accepted
 * residual. Fails toward suppression: a logged-in user missing Braze for
 * one page load self-heals on the next navigation; an anonymous Braze
 * profile is permanent.
 */
export function getLiveAuthSignal(): LiveAuthSignal {
  try {
    const token = store.getState()?.auth?.token;
    if (token) {
      // Epoch milliseconds, or undefined when the token has no decodable
      // numeric `exp` (malformed/opaque tokens count as no session).
      const expiresAtMs = extractExpFromAccessToken(token);
      return expiresAtMs !== undefined && expiresAtMs > Date.now()
        ? 'live_token'
        : 'none';
    }
    return getCookie(AUTH_PROVIDER_COOKIE) ? 'cookie' : 'none';
  } catch {
    // Runs during telemetry init — a throw here would abort the whole
    // Segment load, so never let one escape.
    return 'none';
  }
}

// TELEMETRY-GATE: no Segment/Braze load when telemetry is suppressed.
if (isSaasTelemetryEnabled && typeof window !== 'undefined') {
  deferTelemetryInit(() => {
    // Suppress the Braze device-mode destination unless a LIVE auth session
    // exists (see getLiveAuthSignal). Braze's "Only Track Known Users"
    // gate boots the SDK whenever Segment has ANY persisted user id string —
    // including a stale `ajs_user_id` surviving logout/expiry — and with no
    // identify to attach a user, each such browser mints an anonymous Braze
    // profile (~60k/week, Jul 2026 incident, LCM-472). All other
    // destinations (Segment.io cloud events) load unchanged. The key must
    // match the destination's creation name in the Segment workspace
    // (verified 2026-07-09). Auth state is read at load time; web auth
    // transitions are full-page redirects, so it re-evaluates each time.
    const authSignal = getLiveAuthSignal();
    const hasAuthSession = authSignal !== 'none';

    // Mint-risk attribution telemetry. A persisted Segment user id on a
    // device Braze has never attached a user to (`ab.storage.userId.*`
    // absent) is exactly the state that mints an anonymous Braze profile
    // if the destination boots without an identify landing. Braze's own
    // device data cannot distinguish our desktop webviews from real
    // browsers (WebView2 parses as Chrome), so report the state from
    // inside the app, where isTauri()/desktop_version are ground truth.
    // Counts are an upper bound on actual mints (a sign-in later in the
    // session still attaches the user) — attribution and regression
    // tripwire, not absolutes.
    try {
      // Read both identity stores the way analytics-next's user().id()
      // does ([localStorage, cookie, memory] with getAndSync write-back;
      // per-store JSON-`null` artifacts fall through like
      // UniversalStorage.get). Deliberately skips its last resort, the
      // AJS-classic legacy `ajs_user` cookie — ~zero population today,
      // accepted undercount.
      const normalizeAjsValue = (value: string | null | undefined): string | null =>
        value && value !== 'null' ? value : null;
      const idFromLocalStorage = normalizeAjsValue(
        window.localStorage.getItem('ajs_user_id')
      );
      const idFromCookie = normalizeAjsValue(
        /(?:^|;\s*)ajs_user_id=([^;]+)/.exec(document.cookie)?.[1]
      );
      const persistedAjsUserId = idFromLocalStorage ?? idFromCookie;
      const brazeKnowsUser = Object.keys(window.localStorage).some((key) =>
        key.startsWith('ab.storage.userId')
      );
      if (persistedAjsUserId && !brazeKnowsUser) {
        datadogRum.addAction('braze_boot_unidentified_device', {
          platform: isTauri() ? 'desktop' : 'web',
          desktop_version: getDesktopVersion(),
          // false ⇒ Braze booted in this state and can mint.
          braze_suppressed: !hasAuthSession,
          auth_signal: authSignal,
          // Would the Segment→Braze contains("kp_") filter ever attach
          // this id? Derived booleans only — the raw id is never sent.
          ajs_user_id_contains_kp: persistedAjsUserId.includes('kp_'),
          ajs_user_id_source: idFromLocalStorage ? 'local_storage' : 'cookie',
          // Route template (e.g. /sessions/[sessionId]) — no dynamic ids.
          route: Router.router?.pathname,
        });
      }
    } catch {
      // Attribution only — never interfere with the Segment load below.
    }

    void segmentClient.load(
      {
        writeKey: process.env.NEXT_PUBLIC_SEGMENT_SCRIBE_KEY
          ? process.env.NEXT_PUBLIC_SEGMENT_SCRIBE_KEY
          : '',
        cdnURL: 'https://sys.heidihealth.com',
      },
      {
        integrations: {
          'Segment.io': {
            apiHost: 'sys.heidihealth.com/v1',
            protocol: 'https',
          },
          ...(hasAuthSession ? {} : { 'Braze Web Mode (Actions)': false }),
        },
      }
    );
  });
}

// P2 [3/5]: Segment transport binding for the @heidi/runtime/analytics
// pipeline. Registered at this SDK-owning site per the F5 adapter contract
// (D2) — a suppressed build registers nothing (absence, not a runtime check;
// its segmentClient is a `{ disable: true }` no-op facade anyway).
// `payload.extra` carries the per-call Segment options (pageUrl override).
// TELEMETRY-GATE.
if (isSaasTelemetryEnabled && typeof window !== 'undefined') {
  registerAnalyticsAdapter({
    destination: 'segment',
    enabled: true,
    send: (payload) => {
      void segmentClient.track(
        payload.event,
        payload.props,
        payload.extra as object | undefined
      );
    },
  });
}

/**
 * Lowercase platform identifier matching iOS/Android Amplitude SDK convention
 * (`platform: 'ios' | 'android' | 'web' | 'desktop'`). Use this for the
 * Amplitude SDK built-in `platform` field; cross-platform dashboards in
 * Amplitude / PostHog can break-down by `platform` and naturally see all
 * native clients side-by-side. Distinct from the legacy Heidi-internal
 * `client_platform` (PascalCase `AppType`) which is kept for backward
 * compatibility with existing dashboards.
 */

// `desktop_version` / `app_version` resolution lives in `@/utils/appVersion`.
// Happy path: synchronous build-time value injected from
// `src-tauri/tauri.conf.json` — via `tauri-config.js` for local desktop
// builds, via `$GITHUB_ENV` in `.github/workflows/desktop-app-publish.yml`
// for CI. Fallback path: async `@tauri-apps/api/app::getVersion()`
// initialised once from `_app.tsx`. Either way, callers read via the
// sync `getDesktopVersion()` getter.

/**
 * The authenticated desktop auto-update channel (APP-6116) — `uk`/`eu`/`stable`,
 * or undefined on web / before the region resolves. Sourced from the
 * AUTHENTICATED `kindeProperties.region` (the regulatory key — never
 * `getRegion()`, C10) in the React Query cache, mirroring the Rust updater's
 * `resolve_channel`. Used by the per-event deployment-inventory dim below
 * (`getDeploymentInventoryProps`). The Snowplow / Datadog `client_context`
 * setters live in `OpenFeatureContextSync`, which resolves the same channel
 * from the same authenticated region — so every destination agrees.
 */
const getDesktopUpdateChannel = (): UpdateChannel | undefined => {
  if (!isTauri()) return undefined;
  return resolveUpdateChannel(getCachedKindeRegion());
};

/**
 * Desktop deployment-inventory dimensions (APP-6116 §5.11). Emitted as per-event
 * properties (via `extendedProps`) so they ride on every Amplitude / PostHog /
 * Datadog-RUM-action / Segment event WITHOUT an identify / setUser call — the
 * device-dimension routing discipline keeps these off person-properties so a
 * web↔desktop identity can't clobber another platform's value (last-write-wins).
 *
 * Desktop-only by design: the inventory answers "who runs which desktop build on
 * which channel". `build_id` is the baked CI short SHA (absent on web / local
 * builds). `update_channel` is runtime, derived from the AUTHENTICATED
 * `kindeProperties.region` (the regulatory key — never `getRegion()`, which fails
 * open / honours `?region=`, C10) read from the React Query cache; it mirrors the
 * Rust updater's `resolve_channel`. Both keys are never caller-supplied, so the
 * helper is spread AFTER the event props (system value wins, like installer_type).
 *
 * `region` is deliberately NOT a per-event key here: it is an overloaded event
 * prop (e.g. Evidence events pass `region` for the evidence-content region, not
 * the user's). The authenticated region already reaches analytics via the
 * `identify` person-trait + the Flagsmith `region` trait; `update_channel` is the
 * unambiguous per-event compliance partition (uk/eu/stable).
 */
// Exported for the analytics wiring (src/lib/analytics/wiring.ts), which
// injects these as context getters into the @heidi/runtime/analytics pipeline
// (Wave 1 · P2 [3/5]). They move out of this file when the [4/5] shim deletes
// the model's enrichment copy.
export const getDeploymentInventoryProps = (): {
  build_id?: string;
  update_channel?: UpdateChannel;
} => {
  if (!isTauri()) return {};
  const updateChannel = getDesktopUpdateChannel();
  return {
    ...getBuildIdTraits(),
    ...(updateChannel ? { update_channel: updateChannel } : {}),
  };
};

// The Snowplow suppression denylist lives in
// `@/lib/analytics/snowplow-suppression` and is applied inside the pipeline, so
// every emit gets it regardless of which facade it called. This predicate is
// the app-side reader of the same list; re-exported here for the importers that
// already read it from this module.
export { isSnowplowSuppressedEvent };

export const analyticsScribe = createModel<RootModel>()({
  // P2 [4/5]: the model is STATELESS — `currentTeamId` lives in the
  // @heidi/runtime/analytics context registry (set from setActiveTeam below);
  // `segmentContext` died consumer-less. Do not add state here.
  state: {},
  reducers: {},
  effects: (dispatch) => ({
    setActiveTeam(team: TeamModel) {
      setActiveTeamHost(team);
    },

    // sends segment page event
    trackPage<T extends TrackingProps>(input: { name: SegmentObjectName; props: T }) {
      const { name, props } = input;
      const currentTeamId = getAnalyticsContext().teamId;

      void segmentClient.page(name, {
        ...props,
        action: props.action,
        eventName: props.eventName || `${name} ${props.action}`,
        from_integration: getIntegrationEhrProvider(),
        App: getAppType(),
        $groups: currentTeamId ? { segment_group: currentTeamId } : undefined,
      });
    },

    /**
     * New Event Tracking Framework
     * [Documentation](https://www.notion.so/heidihealth/Event-Database-239ca630286e8079b005dea75cce1ea8)
     *
     * P2 [4/5]: PURE FORWARDER into the @heidi/runtime/analytics pipeline —
     * enrichment, routing, debugger, and destination fan-out live in the
     * package (single source; byte-parity pinned by
     * packages/runtime/src/analytics/parity/expected.ts). The Snowplow
     * suppression it used to apply is now applied inside the pipeline from the
     * app-registered denylist, so every emit gets it whichever facade it
     * called. This effect remains only as the dispatch-compat surface
     * for the contained legacy call sites until the [5/N] codemod retires them.
     * Do NOT add enrichment here.
     */
    trackEventV2(trackingEvent: TrackV2Event) {
      trackV2(trackingEvent);
    },

    /**
     * The v1 Segment/PostHog/Datadog sender. The body lives in
     * `@/lib/analytics/track-legacy-event` so call sites that hold no
     * `dispatch` can emit the same payload; this effect is the dispatch-compat
     * surface for the legacy call sites.
     */
    trackEvent<T extends TrackingProps>(input: {
      name: SegmentObjectName;
      props: T;
      /** Optional URL to override page URL in analytics (useful for preserving attribution params) */
      pageUrl?: string | null;
    }) {
      trackLegacyEvent(input);
    },
    identify(input: {
      authID: string;
      userTraits: {
        email: string;
        email_domain?: string;
        user_ref_id?: Maybe<string>;
        App: AppType;
        country: Maybe<string>;
        region: Maybe<Region>;
        given_name: Maybe<string>;
        family_name: Maybe<string>;
        phone_number?: Maybe<string>;
        has_phone_number?: boolean;
        user_team_id: Maybe<string>;
        user_team_name: Maybe<string>;
        user_team_role: Maybe<UserRole>;
        user_team_plan: Maybe<string>;
        user_team_mfa_enabled: Maybe<boolean>;
        user_joined_team_date: Maybe<string>;
        user_created_date?: Maybe<string>;
        user_tier: Maybe<SubscriptionTier>;
        team_tier: Maybe<SubscriptionTier>;
        effective_tier: Maybe<SubscriptionTier>;
        onboarding_selected_ehr_provider: Maybe<string>;
        ehr_provider: Maybe<EHRProvider>;
        has_integration: Maybe<boolean>;
        // Flag-targeting cohort properties, all read from the same
        // IntegrationOnboardingSession document. Distinct from `ehr_provider`
        // above, which can also resolve from a generic launch or the legacy
        // EHR profile.
        integration_onboarding_provider?: Maybe<EHRProvider>;
        integration_onboarding_created_at?: Maybe<string>;
        integration_onboarding_updated_at?: Maybe<string>;
        /** Active workspace for PostHog cohort targeting. */
        workspace_id?: Maybe<string>;
        source: Maybe<string>;
        signup_attributed_product?: Maybe<string>;
        integration_requests?: Maybe<IntegrationRequest[]>;
        mfa_enabled?: boolean;
        mfa_trigger_source?: string;
        opted_in_experimental?: boolean;
        session_page_v2_enrollment_source?: SessionPageV2EnrollmentSource;
        go_live_time_stamp: Maybe<string>;
        onboarding_free_text: Maybe<string>;
        user_role_list?: Maybe<RoleModel[]>;
        specialty: Maybe<ClinicianTypeInput>;
        localised_specialty: Maybe<ClinicianTypeInput>;
        other_specialty: Maybe<string>;
        display_language: Maybe<LanguageCode>;
        from?: Maybe<string>;
        pathname?: Maybe<string>;
        cpuArch?: string;
        seen_modals?: Maybe<SeenModals>;
        evidence_billing_info?: Maybe<{
          tier: Maybe<string>;
          source: Maybe<string>;
          is_in_free_trial: boolean;
          has_trial_expired: boolean;
          is_stripe_managed: boolean;
        }>;
        evidence_access?: Maybe<string>;
        is_evidence_activated?: Maybe<boolean>;
        is_managed?: Maybe<boolean>;
        /** Enabled access entitlements for PostHog cohort targeting. */
        features?: string[];
      };
    }) {
      const { authID, userTraits } = input;
      const { features, ...traitsWithoutPosthogOnlyFields } = userTraits;
      const commonTraits: CommonTraits = {
        ...traitsWithoutPosthogOnlyFields,
        // `App` (legacy Web/Desktop identity trait) is caller-provided and kept for
        // existing PostHog/Segment/Flagsmith targeting. The finer device/build
        // dimensions (app_type / client_platform / platform / installer_type /
        // distribution_channel / mdm_provider) are NOT user identity — they ride
        // per-event via trackEventV2 rather than as last-write-wins user properties
        // (bce3749bf0 set them on identify; reverted — device dims aren't identity).
        App: getAppType(),
        // Restores APP-4897 per-user filtering on PostHog / Amplitude / Segment
        // / Datadog RUM that broke when APP-4507 (#9756) dropped `desktop_version`
        // from the identify payload. Emits `app_version` in parallel —
        // see `getAppVersionTraits` and `CommonTraits.app_version` for context.
        ...getAppVersionTraits(),
        team_info: {
          team_name: userTraits.user_team_name,
          team_id: userTraits.user_team_id,
          user_team_plan: userTraits.user_team_plan,
          user_joined_team_date: userTraits.user_joined_team_date,
        },
        specialty: userTraits.specialty?.name,
        localised_specialty: userTraits.localised_specialty?.name,
        specialty_group: userTraits.specialty?.group?.name,
        user_role_list: userTraits.user_role_list?.map((role) => ({
          id: role.id,
          name: role.name,
          config: role.config,
        })),
        from: userTraits.from,
        pathname: userTraits.pathname,
      };

      // Segment-specific traits. Ad-platform attribution ids are Segment-only:
      // the Meta / Google Ads CAPI insert functions read them from the unified
      // profile (Meta fbc/fbp; Google gclid/gbraid/wbraid) for later
      // server-side conversions.
      const segmentTraits = {
        ...commonTraits,
        ...getAttributionIdentifyTraits(),
        $groups: userTraits.user_team_id
          ? { segment_group: userTraits.user_team_id }
          : undefined,
      };

      datadogRum.setUser({
        id: authID,
        ...commonTraits,
      });
      setSnowplowUserId(authID);
      setSnowplowUserContext({
        session_page_v2_enrollment_source:
          commonTraits.session_page_v2_enrollment_source ?? null,
      });
      // NOTE: the Snowplow client_context `update_channel` is NOT set here.
      // identify can run before the Kinde-properties query resolves, which would
      // strand Snowplow at null for the session. It's set from
      // OpenFeatureContextSync instead — that hook subscribes to
      // useQueryKindeProperties, so it re-attaches the channel once the region
      // resolves (APP-6116).
      // `posthog.identify` already persists these traits and emits the events
      // PostHog expects: `$identify` on first identification, then `$set`
      // whenever a trait actually changes (it hashes distinct_id + $set and
      // no-ops when nothing differs). A manual `capture('$identify')` used to
      // follow this line to feed two Braze feature-flag destinations, but it
      // fired unconditionally — ~4.25M events a week, 85% of the `$identify`
      // volume — to deliver attributes those destinations then deduplicated to
      // one delivery per person per hour. Both destinations have since been
      // deleted, so the duplicate is pure cost. Note that Braze profile
      // identity comes from Segment (below), not PostHog, and Braze
      // transactional email is sent by the backend.
      // `pathname` is deliberately withheld from PostHog, and ONLY from PostHog.
      // PostHog hashes (distinct_id + $set + $set_once) and short-circuits an
      // identify whose hash is unchanged, so a trait that changes on every
      // navigation forces a billable `/flags` reload plus a `$set` event per
      // route change. Amplitude / Segment / Datadog RUM have no such cost and
      // still receive it, so this filter must not move up into `commonTraits`.
      const posthogOmittedTraits = new Set(['pathname']);
      const posthogTraits = Object.fromEntries(
        Object.entries(commonTraits).filter(([key]) => !posthogOmittedTraits.has(key))
      );
      if (features) {
        posthogTraits.features = features;
      }
      posthog.identify(authID, posthogTraits);
      void segmentClient.identify(authID, segmentTraits);

      // Prefer user_ref_id as the canonical Amplitude user id (cross-platform,
      // stable across auth providers). Falls back to the Kinde id only on the
      // first identify before useQueryUser has resolved. Note: this creates a
      // brief window where events are attributed to a Kinde-id-keyed profile
      // before the second identify swaps to user_ref_id — Amplitude's SDK
      // auto-merges anonymous-device activity onto a named user, but it does
      // NOT auto-merge two named user ids. The two profiles are explicitly
      // stitched by the one-off /usermap backfill in ml-scribe PR #9469.
      amplitude.setUserId(userTraits.user_ref_id ?? authID);

      // if sending email field, get the domain of the email to set email_domain property
      if (commonTraits.email) {
        const emailDomain = commonTraits.email.split('@')[1];
        commonTraits.email_domain = emailDomain;
      }

      commonTraits.has_phone_number = Boolean(commonTraits.phone_number);

      // Filter out PII fields before sending to Amplitude
      const piiFields = new Set(['email', 'given_name', 'family_name', 'phone_number']);

      const amplitudeTraits = Object.fromEntries(
        Object.entries(commonTraits).filter(([key]) => !piiFields.has(key))
      );

      const identifyObj = new AmplitudeIdentify();
      for (const [key, value] of Object.entries(amplitudeTraits)) {
        if (value != null) {
          identifyObj.set(key, value as AmplitudePropertyType);
        }
      }

      // Retain kinde_user_id as a user property so historical dashboards and
      // cohorts that filtered on it continue to resolve after the user-id swap.
      identifyObj.set('kinde_user_id', authID);

      const currentAuthProvider = store.getState().auth?.authProvider;
      const providerValue = mapAuthProviderToProvider(currentAuthProvider);
      if (providerValue) {
        identifyObj.set('authentication_provider', providerValue);
      }

      amplitude.identify(identifyObj);

      // Set group for team-based analytics
      if (userTraits.user_team_id) {
        amplitude.setGroup('team', userTraits.user_team_id);
      }

      // RC custom signals for Desktop targeting — shared Mobile+Desktop keys
      // (hardware signals set from chronicle sync). Firebase SDK loads lazily
      // inside the custom-signals helper, not at import time.
      // identify is shared with web/FHIR; only Desktop may claim DesktopApp —
      // null clears a stale platform signal if this bag was written earlier.
      setRemoteConfigCustomSignals({
        ...(authID ? { kinde_user_id: authID } : {}),
        native_platform_source: isTauri() ? DESKTOP_NATIVE_PLATFORM_SOURCE : null,
        os_version: formatRemoteConfigOsVersion(getDesktopOsVersion()),
        region: formatRemoteConfigRegion(
          userTraits.region != null ? String(userTraits.region) : null
        ),
        ...(userTraits.user_ref_id ? { user_ref_id: userTraits.user_ref_id } : {}),
      });
    },

    /**
     * Clears Segment's persisted identity (`ajs_user_id`, anonymous id,
     * traits) on logout — parity with the PostHog / Amplitude / Snowplow
     * resets authModel already performs. A user id surviving logout boots
     * the Braze device-mode destination on logged-out pages (anonymous
     * Braze profile per browser, Jul 2026 incident) and attributes
     * logged-out events to a shared machine's previous user.
     */
    resetIdentity() {
      resetIdentityHost();
    },

    /**
     * Sets the `auth_type` Amplitude user property at sign-in time, when the
     * sign-in method is still available. Call from auth success handlers.
     */
    setAuthTypeUserProperty(authType: AuthType) {
      setAuthTypeUserPropertyHost(authType);
    },
    trackScreenViewed(props: ScreenEventProps) {
      trackScreenViewedHost(props);
    },

    trackFieldSelected(input: {
      fieldName: string;
      fieldType: FieldType;
      screenName: ScreenName;
      screenSection?: string;
      /** Wizard step slug (e.g. dictate onboarding). */
      stepName?: string;
      // Selected value, for bounded non-PII fields (e.g. the onboarding
      // EMR/EHR and specialty dropdowns). Never pass for free-text fields —
      // see the field_value note on FieldSelectedEventProps.
      fieldValue?: string;
      // Funnel-stitching for the patient find-or-link combobox; nullable on
      // every other field_selected caller (template fields, etc.). See the
      // generated FieldSelected schema (v1-1-0) for the contract.
      searchId?: string;
      featureFlagVariant?: 'treated' | 'control' | 'unknown';
      country?: string;
      language?: string;
      // Destination control passthrough. Omitted on the pre-policy call sites
      // (Amplitude stays ON by default for them); new call sites must pass
      // `{ amplitude: false }` per the Snowplow-first routing policy.
      options?: { segment?: boolean; posthog?: boolean; amplitude?: boolean };
    }) {
      trackFieldSelectedHost(input);
    },

    /**
     * Dispatch a `button_clicked` event to Snowplow + Datadog only.
     *
     * Routing policy: this helper forces `amplitude: false` regardless of
     * the caller — `button_clicked` is mid-migration off Amplitude and
     * consolidates on Snowplow as the source of truth. **All new
     * `button_clicked` dispatches must go through this helper** rather
     * than calling `trackEventV2` directly.
     *
     * Accepts two shapes for backwards compatibility:
     *
     *  1. **Snake_case (preferred for new code):** full `ButtonEventProps`
     *     shape — `screen_name` and `action` are required at the helper
     *     boundary even though they're optional on the underlying type, so
     *     no caller can fire a screen-less / action-less button event.
     *     Pass any other optional field (`session_id`, `feature`,
     *     `integration_slug`, …) through directly.
     *  2. **CamelCase (legacy):** `screenName` + `action` + `label` plus
     *     the optional `taskId` / `clickSource` shortcuts kept around for
     *     the ~30 pre-existing call sites. New code should prefer the
     *     snake_case shape.
     *
     * See `.claude/skills/analytics-validator/SKILL.md` for the wider
     * policy.
     */
    trackButtonClicked(input: TrackButtonClickedInput) {
      trackButtonClickedHost(input);
    },
    trackModalViewed(input: { screenName: ScreenName }) {
      trackModalViewedHost(input);
    },
    trackPatientSummarySmsSendAttempted(input: PatientSummarySmsSendAttemptedEventProps) {
      trackPatientSummarySmsSendAttemptedHost(input);
    },
    trackPatientSummarySmsSent(input: PatientSummarySmsSentEventProps) {
      trackPatientSummarySmsSentHost(input);
    },
    /**
     * Total patient-summary email send volume — fired when the clinician
     * confirms the recipient and clicks Send in the M0 "Send to patient"
     * flow, before the dispatch result. Snowplow-only (`amplitude: false`):
     * as a new event it is forwarded to Amplitude by the Snowplow pipeline
     * (tagged `source_system = 'Snowplow'`), so a direct Amplitude call would
     * double-count. Pair with `trackPatientSummaryEmailSent` to derive the
     * success rate.
     */
    trackPatientSummaryEmailSendAttempted(
      input: PatientSummaryEmailSendAttemptedEventProps
    ) {
      trackPatientSummaryEmailSendAttemptedHost(input);
    },
    /**
     * Successful patient-summary email dispatch (backend accepted the send).
     * Snowplow-only (`amplitude: false`): the Snowplow pipeline forwards this
     * new event to Amplitude, so a direct Amplitude call would double-count.
     */
    trackPatientSummaryEmailSent(input: PatientSummaryEmailSentEventProps) {
      trackPatientSummaryEmailSentHost(input);
    },
    /**
     * Impression for the "Send to patient" CTA — fired once per document when
     * the visible canvas chip (the dynamic button) renders. Gives the send
     * funnel its top-of-funnel denominator (shown → open → send). Snowplow-only
     * (`amplitude: false`): as a new event it is forwarded to Amplitude by the
     * Snowplow pipeline (tagged `source_system = 'Snowplow'`), so a direct
     * Amplitude call would double-count.
     */
    trackPatientSummaryCtaShown(input: PatientSummaryCtaShownEventProps) {
      trackPatientSummaryCtaShownHost(input);
    },
    trackPatientExtractionModalOpened(input: PatientExtractionModalOpenedEventProps) {
      trackPatientExtractionModalOpenedHost(input);
    },
    trackPatientExtractionReviewed(input: PatientExtractionReviewedEventProps) {
      trackPatientExtractionReviewedHost(input);
    },
    trackPatientViewed(input: PatientViewedEventProps) {
      trackPatientViewedHost(input);
    },
    trackPatientUpdated(input: PatientUpdatedEventProps) {
      trackPatientUpdatedHost(input);
    },
    trackPatientContextToggleOn(input: PatientContextToggleOnEventProps) {
      trackPatientContextToggleOnHost(input);
    },
    trackPatientContextToggleOff(input: PatientContextToggleOffEventProps) {
      trackPatientContextToggleOffHost(input);
    },
    trackContextPreviewed(input: ContextPreviewedEventProps) {
      trackContextPreviewedHost(input);
    },
    trackContextLinked(input: ContextLinkedEventProps) {
      trackContextLinkedHost(input);
    },
    trackContextUnlinked(input: ContextUnlinkedEventProps) {
      trackContextUnlinkedHost(input);
    },

    // Sign In
    signInClicked(sign_in_method?: 'email' | 'google' | 'microsoft' | 'apple') {
      const authType = mapSignInMethodToAuthType(sign_in_method);

      dispatch.analyticsScribe.trackEvent({
        name: SegmentObjectName.SignIn,
        props: {
          action: SegmentActionName.SignInClicked,
          sign_in_method,
        },
      });

      // V2 — authentication_clicked
      dispatch.analyticsScribe.trackEventV2({
        options: { amplitude: false },
        event_name: TrackingEventName.AuthenticationClicked,
        props: buildAuthenticationClickedProps({
          clickAction: sign_in_method,
          provider: mapAuthProviderToProvider(store.getState().auth?.authProvider),
        }),
      });

      if (authType) {
        dispatch.analyticsScribe.setAuthTypeUserProperty(authType);
      }

      setSignInMethod(sign_in_method ?? '');
    },
    // Sign Up — onboarding-completion conversion signal.
    //
    // The v2 `user_signed_up` event no longer fires here; it now fires
    // immediately after web auth via `trackSignUpSuccessfulWebAuth` so the
    // "user signed up" event reflects auth success, not whether the user
    // finished personalization. This function keeps the legacy GA dataLayer
    // push + Segment event for marketing conversion attribution that
    // historically tied to onboarding completion.
    trackSignupSuccessful(input: {
      baaRequired?: boolean;
      complianceKitRequired?: boolean;
      phoneNumberProvided?: boolean;
    }) {
      trackSignupSuccessfulHost(input);
    },

    trackSignUpSuccessfulWidgetAuth(input: { integration_type: IntegrationType }) {
      dispatch.analyticsScribe.trackEventV2({
        options: { amplitude: false },
        event_name: TrackingEventName.UserSignedUp,
        props: {
          integration_type: input.integration_type,
          provider: mapAuthProviderToProvider(store.getState().auth?.authProvider),
        },
      });
    },
    trackSignInSuccessfulWidgetAuth(input: { integration_type: IntegrationType }) {
      dispatch.analyticsScribe.trackEventV2({
        options: { amplitude: false },
        event_name: TrackingEventName.UserSignedIn,
        props: {
          integration_type: input.integration_type,
          provider: mapAuthProviderToProvider(store.getState().auth?.authProvider),
        },
      });
    },

    trackSignInSuccessfulWebAuth(input: {
      auth_provider: AuthProvider;
      sign_in_method: SignInMethod;
    }) {
      trackSignInSuccessfulWebAuthHost(input);
    },

    /**
     * Fires `user_signed_up` immediately after web auth completes for a new
     * user (Kinde/Auth0 callback with `screenHint=signup`). Mirrors
     * `trackSignInSuccessfulWebAuth` for returning users.
     *
     * The onboarding-end `trackSignupSuccessful` retains its legacy GA
     * dataLayer push + Segment event for marketing conversion attribution,
     * but the v2 `user_signed_up` event lives here so it reflects the real
     * auth-success moment (not whether the user finished personalization).
     */
    trackSignUpSuccessfulWebAuth(input: {
      auth_provider: AuthProvider;
      sign_in_method: SignInMethod;
    }) {
      trackSignUpSuccessfulWebAuthHost(input);
    },
    signUpFlowStarted() {
      signUpFlowStartedHost();
    },
    signUpPhoneNumberChanged(input: { country: string; phoneNumber: string }) {
      signUpPhoneNumberChangedHost(input);
    },
    trackSignUpViaTeamInvite(input: { authID: string }) {
      const { authID } = input;

      dispatch.analyticsScribe.trackEvent({
        name: SegmentObjectName.SignUp,
        props: {
          action: SegmentActionName.SignUpViaTeamInvite,
        },
      });

      posthog.identify(authID, {
        signed_up_via_invite: true,
        from: 'team-invite',
      });

      // V2 — user_signed_up (via team invite)
      dispatch.analyticsScribe.trackEventV2({
        options: { amplitude: false },
        event_name: TrackingEventName.UserSignedUp,
        props: {
          provider: mapAuthProviderToProvider(store.getState().auth?.authProvider),
        },
      });
    },
    sessionCreated(sessionId: string) {
      sessionCreatedHost(sessionId);
    },
    selectLanguage(input: {
      selectLanguage: LanguageCode;
      multipleLanguages?: LanguageCode[];
      outputLanguage?: SessionUpdate['language_code'];
    }) {
      selectLanguageHost(input);
    },
    uploadRecording(input: { size: number; sessionId: string }) {
      uploadRecordingHost(input);
    },
    uploadRecordingSuccess(input: { size: number; sessionId: string }) {
      uploadRecordingSuccessHost(input);
    },
    uploadRecordingFailed(input: { size: number; sessionId: string }) {
      uploadRecordingFailedHost(input);
    },
    uploadRecordingCancelled(size: number) {
      uploadRecordingCancelledHost(size);
    },
    chooseDictation(sessionId: string) {
      chooseDictationHost(sessionId);
    },
    chooseTranscribe() {
      chooseTranscribeHost();
    },

    sessionChooseMicInput(microphone: string) {
      sessionChooseMicInputHost(microphone);
    },

    /**
     * APP-7915 WS4 warning funnel: silent-capture warning shown. Snowplow +
     * Datadog only — always dispatch through this helper (it is the routing
     * chokepoint), never via a raw `trackEventV2` call.
     */
    audioWarningViewed(props: AudioWarningEventProps) {
      audioWarningViewedHost(props);
    },

    /**
     * APP-7915 WS4 warning funnel: user clicked the warning's one-click fix.
     * Snowplow + Datadog only — always dispatch through this helper. There is
     * intentionally no `audioWarningDismissed`: toast dismissal is not
     * observable; "viewed but unacted" is approximated from residual capture
     * silence at recording stop.
     */
    audioWarningAccepted(props: AudioWarningEventProps) {
      audioWarningAcceptedHost(props);
    },

    sessionStartRecording(input: {
      sessionId: string;
      transcribeMode: SessionResponse['transcribe_mode'];
      device?: string;
      deviceId?: string;
      isRecordingV2Enabled?: boolean;
      isTabSharing?: boolean;
      transcriptionServiceVersion?: 'v1' | 'v2';
      /** APP-7962: desktop speaker capture mode (shared with `capture_summary`). */
      captureMode?: CaptureMode;
      /** APP-7962: how the desktop mic selection resolved (explicit / console_default / comms_default). */
      inputDefaultKind?: InputDefaultKind;
    }) {
      sessionStartRecordingHost(input);
    },

    sessionPauseRecording(input: {
      sessionId: string;
      isRecordingV2Enabled?: boolean;
      isTabSharing?: boolean;
    }) {
      sessionPauseRecordingHost(input);
    },

    sessionStopRecording(input: {
      sessionId: string;
      duration: number;
      isRecordingV2Enabled?: boolean;
      isTabSharing?: boolean;
    }) {
      sessionStopRecordingHost(input);
    },

    sessionResumeRecording(input: {
      sessionId: string;
      isRecordingV2Enabled?: boolean;
      isTabSharing?: boolean;
      /** APP-7962: desktop speaker capture mode (shared with `capture_summary`). */
      captureMode?: CaptureMode;
      /** APP-7962: how the desktop mic selection resolved (explicit / console_default / comms_default). */
      inputDefaultKind?: InputDefaultKind;
    }) {
      sessionResumeRecordingHost(input);
    },

    sessionPatientDetailsUpdated() {
      dispatch.analyticsScribe.trackEvent({
        name: SegmentObjectName.Session,
        props: {
          action: SegmentActionName.SessionPatientDetailsUpdated,
        },
      });
    },

    sessionDeleted(sessionId: string) {
      dispatch.analyticsScribe.trackEvent({
        name: SegmentObjectName.Session,
        props: {
          action: SegmentActionName.SessionDeleted,
          sessionId: sessionId,
        },
      });
    },

    sessionCopyClicked(input: {
      format: SessionCopiedFormat;
      copyMethod: CopyMethod;
      selectedWordCount: number;
      totalWordCount: number;
      /** Which affordance the copy came from. */
      copySource: SessionCopySource;
      /**
       * Whether a `text/html` sibling accompanied `text/plain`. Required
       * because every emit site already branches on it — `format` alone
       * cannot express a toggle copy that wrote plain text only.
       */
      htmlFlavorWritten: boolean;
      /** Toggle state at copy time, on every format. */
      copySettings?: CopySettingsSnapshot;
      /** Editor variant, so copies are segmentable by editor. */
      editorType?: NoteEditorType;
    }) {
      sessionCopyClickedHost(input);
    },
    copySettingsUpdated(input: {
      setting: CopySetting;
      isEnabled: boolean;
      copySettings: CopySettingsSnapshot;
    }) {
      copySettingsUpdatedHost(input);
    },
    assistantPanelAction(props: AssistantPanelActionEventProps) {
      assistantPanelActionHost(props);
    },
    sessionTemplateUpdated(input: { sessionId: string; templateId: string }) {
      sessionTemplateUpdatedHost(input);
    },
    sessionDeleteByIds(input?: { sessionCount?: number }) {
      sessionDeleteByIdsHost(input);
    },
    sessionAllDeleted() {
      sessionAllDeletedHost();
    },
    sessionVoiceUpdated(input: {
      voiceStyle?: VoiceStyle;
      oldVoiceStyle?: VoiceStyle;
      sessionId: string;
    }) {
      sessionVoiceUpdatedHost(input);
    },
    sessionDateTimeUpdated(input: { sessionId: string; createdTimeLocal: string }) {
      sessionDateTimeUpdatedHost(input);
    },
    sessionViewed({ sessionId }: { sessionId: string }) {
      sessionViewedHost({ sessionId });
    },
    contextAddContent(input: { sessionId: string; wordCount: number; userId: string }) {
      contextAddContentHost(input);
    },

    // streaming
    noteGenerationStart({
      sessionId,
      documentId,
      startTime,
      isRecordingV2Enabled,
      isTabSharing,
      is_pinned_template,
      is_starter_pack_template,
      generation_method,
    }: {
      sessionId: string;
      documentId?: string;
      startTime: number;
      isRecordingV2Enabled?: boolean;
      isTabSharing?: boolean;
      is_pinned_template: boolean;
      is_starter_pack_template: boolean;
      generation_method?: GenerationMethod | null;
    }) {
      noteGenerationStartHost({
        sessionId,
        documentId,
        startTime,
        isRecordingV2Enabled,
        isTabSharing,
        is_pinned_template,
        is_starter_pack_template,
        generation_method,
      });
    },

    gotFirstNonEmptyTranscriptChunk({
      sessionId,
      isTabSharing,
    }: {
      sessionId: string;
      isTabSharing?: boolean;
    }) {
      gotFirstNonEmptyTranscriptChunkHost({
        sessionId,
        isTabSharing,
      });
    },

    noteGenerationFinished({
      isSuccess,
      sessionId,
      documentId,
      totalDuration,
      durationBeforeWaitingUpload,
      durationWaitingToUpload,
      durationWaitingToStream,
      durationStreaming,
      durationCompletingStreaming,
      isRecordingV2Enabled,
      isTabSharing,
      error,
    }: {
      isSuccess: boolean;
      sessionId: string;
      documentId?: string;
      totalDuration?: number;
      durationBeforeWaitingUpload?: number;
      durationWaitingToUpload?: number;
      durationWaitingToStream?: number;
      durationStreaming?: number;
      durationCompletingStreaming?: number;
      isRecordingV2Enabled?: boolean;
      isTabSharing?: boolean;
      error?: string;
    }) {
      noteGenerationFinishedHost({
        isSuccess,
        sessionId,
        documentId,
        totalDuration,
        durationBeforeWaitingUpload,
        durationWaitingToUpload,
        durationWaitingToStream,
        durationStreaming,
        durationCompletingStreaming,
        isRecordingV2Enabled,
        isTabSharing,
        error,
      });
    },

    // TODO: deperecate this
    noteGenerationEnd({
      sessionId,
      documentId,
      endTime,
      is_pinned_template,
      is_starter_pack_template,
    }: {
      sessionId: string;
      documentId?: string;
      endTime: number;
      is_pinned_template: boolean;
      is_starter_pack_template: boolean;
    }) {
      noteGenerationEndHost({
        sessionId,
        documentId,
        endTime,
        is_pinned_template,
        is_starter_pack_template,
      });
    },
    noteAutoRetryDecided(props: Parameters<typeof noteAutoRetryDecidedHost>[0]) {
      noteAutoRetryDecidedHost(props);
    },
    noteGenerationError({
      sessionId,
      error_code,
      documentId,
      is_pinned_template,
      is_starter_pack_template,
      generation_method,
    }: {
      sessionId: string;
      error_code: NoteFailedErrorCode;
      documentId?: string;
      is_pinned_template?: boolean;
      is_starter_pack_template?: boolean;
      generation_method?: GenerationMethod | null;
    }) {
      noteGenerationErrorHost({
        sessionId,
        error_code,
        documentId,
        is_pinned_template,
        is_starter_pack_template,
        generation_method,
      });
    },
    templateAskAiByPreset(presetCommandId?: string) {
      dispatch.analyticsScribe.trackEvent({
        name: SegmentObjectName.Template,
        props: {
          action: SegmentActionName.templateAskAiByPreset,
          presetCommandId: presetCommandId,
        },
      });
    },
    templateCreateNewClicked() {
      templateCreateNewClickedHost();
    },
    templateCreateAskAi(payload: { aiCommandText: string }) {
      templateCreateAskAiHost(payload);
    },
    templateCreateUseExistingClicked() {
      templateCreateUseExistingClickedHost();
    },
    templateCreateUseScratchClicked() {
      templateCreateUseScratchClickedHost();
    },

    // The one authoritative `template_created` emission for non-PDF creations
    // (PDF goes via `trackPDFTemplateCreated`).
    trackTemplateCreated({
      templateId,
      templateName,
      teamId,
      version,
      sectionCount,
      source,
      aiCommandText,
      useSections,
    }: {
      templateId?: string;
      templateName?: string;
      teamId?: string;
      version?: 'v1' | 'v2';
      sectionCount?: number;
      source?: TemplateCreationSource;
      /** The prompt behind an `ask_ai` creation. */
      aiCommandText?: string;
      useSections?: boolean;
    }) {
      trackTemplateCreatedHost({
        templateId,
        templateName,
        teamId,
        version,
        sectionCount,
        source,
        aiCommandText,
        useSections,
      });
    },
    trackTemplateUpdated({
      templateId,
      templateName,
      teamId,
      version,
      sectionCount,
      templateType,
      useSections,
    }: {
      templateId?: string;
      templateName?: string;
      teamId?: string;
      version: 'v1' | 'v2';
      sectionCount?: number;
      /**
       * Template category of the saved template. Without it a patient-summary
       * template edit is indistinguishable from any other save, since
       * `template_name` is clinician-authored.
       */
      templateType?: string;
      useSections?: boolean;
    }) {
      trackTemplateUpdatedHost({
        templateId,
        templateName,
        teamId,
        version,
        sectionCount,
        templateType,
        useSections,
      });
    },

    trackTemplateEditorUpdated({
      templateId,
      tabType,
      version,
    }: {
      templateId?: string;
      tabType: 'example' | 'structure';
      version: 'v1' | 'v2';
    }) {
      trackTemplateEditorUpdatedHost({
        templateId,
        tabType,
        version,
      });
    },

    trackTemplateGeneration({
      templateId,
      src,
      useSections,
    }: {
      templateId?: string;
      src: 'chat' | 'example' | 'structure';
      useSections?: boolean;
    }) {
      trackTemplateGenerationHost({
        templateId,
        src,
        useSections,
      });
    },

    trackTemplateCreationRecordCreated({
      requestMethods,
    }: {
      requestMethods: RequestMethod[];
    }) {
      trackTemplateCreationRecordCreatedHost({
        requestMethods,
      });
    },
    trackTemplateOpened({
      templateId,
      templateAuthorGroup,
      version,
    }: {
      templateId: string;
      templateAuthorGroup?: TemplateAuthorGroup | null;
      version: 'v1' | 'v2';
    }) {
      trackTemplateOpenedHost({ templateId, templateAuthorGroup, version });
    },

    trackPDFTemplateCreated({
      templateId,
      templateName,
      teamId,
      sectionCount,
    }: {
      templateId: string;
      templateName: string;
      teamId?: string | null;
      sectionCount?: number;
    }) {
      trackPDFTemplateCreatedHost({
        templateId,
        templateName,
        teamId,
        sectionCount,
      });
    },
    documentCreateClick() {
      documentCreateClickHost();
    },
    documentRedo() {
      documentRedoHost();
    },
    documentUndo() {
      documentUndoHost();
    },

    documentExported(props: DocumentExportedEventProps) {
      documentExportedHost(props);
    },

    documentExportPdf({
      sessionId,
      documentId,
      export_context,
      hasHeader,
      hasFooter,
      hasSignature,
      settingsPipeline,
      copySettings,
    }: {
      sessionId: string;
      documentId: string;
      export_context?: DocumentExportContext;
      hasHeader?: boolean;
      hasFooter?: boolean;
      hasSignature?: boolean;
      settingsPipeline?: SettingsPipeline;
      copySettings?: CopySettingsSnapshot;
    }) {
      documentExportPdfHost({
        sessionId,
        documentId,
        export_context,
        hasHeader,
        hasFooter,
        hasSignature,
        settingsPipeline,
        copySettings,
      });
    },

    documentExportDoc({
      sessionId,
      documentId,
      hasHeader,
      hasFooter,
      hasSignature,
      settingsPipeline,
      copySettings,
    }: {
      sessionId: string;
      documentId: string;
      hasHeader?: boolean;
      hasFooter?: boolean;
      hasSignature?: boolean;
      settingsPipeline?: SettingsPipeline;
      copySettings?: CopySettingsSnapshot;
    }) {
      documentExportDocHost({
        sessionId,
        documentId,
        hasHeader,
        hasFooter,
        hasSignature,
        settingsPipeline,
        copySettings,
      });
    },

    documentSelectionCopyAll() {
      documentSelectionCopyAllHost();
    },
    documentSelectionSendEmail({
      email,
      documentId,
      sessionId,
      is_pinned_template,
      is_starter_pack_template,
      recipient_count,
      included_link,
      link_scope,
      link_ttl,
      partial_failure,
    }: {
      email: string;
      documentId: string;
      /** Session the document belongs to. Omitted when not in a session context. */
      sessionId?: string;
      is_pinned_template: boolean;
      is_starter_pack_template: boolean;
      /** Total number of recipients targeted by the send. */
      recipient_count?: number;
      /** True when the merged modal's "Read-only session link" was on at submit. */
      included_link?: boolean;
      /** Scope of the link share. Only set when included_link is true. */
      link_scope?: string;
      /** TTL of the link share. Only set when included_link is true. */
      link_ttl?: string;
      /** True when at least one of the two mutations failed but at least one succeeded. */
      partial_failure?: boolean;
    }) {
      documentSelectionSendEmailHost({
        email,
        documentId,
        sessionId,
        is_pinned_template,
        is_starter_pack_template,
        recipient_count,
        included_link,
        link_scope,
        link_ttl,
        partial_failure,
      });
    },
    documentSelectionSetAsDefaultTemplate() {
      documentSelectionSetAsDefaultTemplateHost();
    },

    documentSelectionSaveAsNew() {
      documentSelectionSaveAsNewHost();
    },
    documentSelectionViewStructure() {
      documentSelectionViewStructureHost();
    },
    documentSelectionRegenerateOutput() {
      documentSelectionRegenerateOutputHost();
    },
    documentDeleted(input: {
      is_pinned_template?: boolean;
      is_starter_pack_template?: boolean;
    }) {
      documentDeletedHost(input);
    },
    documentRegeneratedByTemplate(templateId: string) {
      documentRegeneratedByTemplateHost(templateId);
    },
    documentRegeneratedByAskAI(aiCommandId: string) {
      documentRegeneratedByAskAIHost(aiCommandId);
    },
    documentCreatedByTemplate(templateId?: string) {
      documentCreatedByTemplateHost(templateId);
    },
    documentCreatedByAskAI(aiCommandText?: string) {
      documentCreatedByAskAIHost(aiCommandText);
    },
    documentCreatedByAICommand(aiCommandId?: string) {
      documentCreatedByAICommandHost(aiCommandId);
    },
    documentSyncChangesClicked() {
      documentSyncChangesClickedHost();
    },
    noteSelectionRegenerateOutput() {
      noteSelectionRegenerateOutputHost();
    },
    noteGeneratedByTemplate(templateId: string) {
      noteGeneratedByTemplateHost(templateId);
    },
    noteGeneratedByPressAICommand(aiCommandId: string) {
      noteGeneratedByPressAICommandHost(aiCommandId);
    },
    noteGeneratedByAskAI(aiCommandText: string) {
      noteGeneratedByAskAIHost(aiCommandText);
    },
    askAi({
      questionAskedLength,
      sessionId,
    }: {
      questionAskedLength: number;
      sessionId: string;
    }) {
      askAiHost({ questionAskedLength, sessionId });
    },
    askAiCopy() {
      askAiCopyHost();
    },
    askAiAddToNote(mode?: string) {
      askAiAddToNoteHost(mode);
    },
    askAiReplaceNote(mode?: string) {
      askAiReplaceNoteHost(mode);
    },
    askAiAddAsNewOutput(mode?: string) {
      askAiAddAsNewOutputHost(mode);
    },

    // Snowplow-first companion to the legacy askAi insert events: records the
    // format a chat/Ask-Heidi insert stored (raw markdown vs converted HTML), to
    // correlate the markdown-native insert path with `note_editor_render_failed`
    // during the Labs rollout.
    noteInsertApplied(params: {
      insertAction: NoteInsertAction;
      editorVariant: NoteInsertEditorVariant;
      sessionId?: string | null;
      mode?: string;
      chatId?: string | null;
      messageId?: string | null;
    }) {
      noteInsertAppliedHost(params);
    },
    askAiRegenerate() {
      askAiRegenerateHost();
    },
    askHeidiOpened() {
      askHeidiOpenedHost();
    },
    askHeidiClosed(mode?: string) {
      askHeidiClosedHost(mode);
    },
    askHeidiCitationClicked(params: {
      citationUrl: string;
      citationTitle: string;
      sessionId: string;
      citationSource: 'response' | 'sources';
    }) {
      askHeidiCitationClickedHost(params);
    },
    askHeidiCsatModalOpened(params: {
      mode?: string;
      feedbackType: 'positive' | 'negative';
    }) {
      askHeidiCsatModalOpenedHost(params);
    },
    trackFeedbackModalSelectedRate(
      input: { rating: CSATRating } & FeedbackEventTrackBaseProps
    ) {
      trackFeedbackModalSelectedRateHost(input);
    },
    trackFeedbackModalReasonSelected(reasons: FeedbackTags) {
      trackFeedbackModalReasonSelectedHost(reasons);
    },
    trackNoteFeedbackSubmitted(input: FeedbackRequest & FeedbackEventTrackBaseProps) {
      trackNoteFeedbackSubmittedHost(input);
    },
    saveSettings(settingsUpdatedData: UpdateUserRequest) {
      saveSettingsHost(settingsUpdatedData);
    },
    exportSettingToggled({
      type,
      enabled,
      scope,
      teamId,
    }: {
      type: ExportSettingType;
      enabled: boolean;
      scope: ExportSettingScope;
      teamId?: string;
    }) {
      exportSettingToggledHost({ type, enabled, scope, teamId });
    },
    exportContentSaved(props: ExportContentSavedEventProps) {
      exportContentSavedHost(props);
    },
    settingsManageBillingClicked(input?: { current_plan?: SubscriptionTier }) {
      settingsManageBillingClickedHost(input);
    },
    settingsTrialBillingCancelTrialClick(input: { current_plan: SubscriptionTier }) {
      settingsTrialBillingCancelTrialClickHost(input);
    },
    settingsBillingTrialUpgradeNowClick(input: { current_plan: SubscriptionTier }) {
      settingsBillingTrialUpgradeNowClickHost(input);
    },
    settingsBillingCurrentPlanUpgradeClicked(currentPlan: SubscriptionTier) {
      settingsBillingCurrentPlanUpgradeClickedHost(currentPlan);
    },
    settingsBillingEnterpriseGetInTouchClicked(currentPlan: SubscriptionTier) {
      settingsBillingEnterpriseGetInTouchClickedHost(currentPlan);
    },
    integrationRequest(input: IntegrationRequest) {
      integrationRequestHost(input);
    },
    navigationRoadmap() {
      navigationRoadmapHost();
    },
    navigationHelp() {
      navigationHelpHost();
    },
    navigationLogout() {
      dispatch.analyticsScribe.trackEvent({
        name: SegmentObjectName.General,
        props: {
          action: SegmentActionName.NavigationLogout,
        },
      });

      dispatch.analyticsScribe.trackEventV2({
        event_name: TrackingEventName.UserSignedOut,
        props: {
          screen_section: SignOutLocation.NAVIGATION_SIDEBAR,
          auth_provider: store.getState().auth?.authProvider,
          provider: mapAuthProviderToProvider(store.getState().auth?.authProvider),
        },
        options: { amplitude: false, posthog: true },
      });
    },
    navigationLogoutWidgetAuth() {
      dispatch.analyticsScribe.trackEventV2({
        options: { amplitude: false },
        event_name: TrackingEventName.UserSignedOut,
        props: {
          screen_section: SignOutLocation.WIDGET_AUTH_PAGE,
          auth_provider: store.getState().auth?.authProvider,
          provider: mapAuthProviderToProvider(store.getState().auth?.authProvider),
        },
      });
    },
    navigationGermanCall() {
      navigationGermanCallHost();
    },
    navigationGetStartedFAQ() {
      navigationGetStartedFAQHost();
    },
    navigationFranceCall() {
      navigationFranceCallHost();
    },
    navigationSpanishCall() {
      navigationSpanishCallHost();
    },
    navigationDiscoveryCall() {
      navigationDiscoveryCallHost();
    },
    paywallModalOpenFromProActionOnFree() {
      paywallModalOpenFromProActionOnFreeHost();
    },
    paywallModalOpenFromExtendProTrial() {
      paywallModalOpenFromExtendProTrialHost();
    },
    paywallModalOpenFromVisibilityToTeam() {
      paywallModalOpenFromVisibilityToTeamHost();
    },
    paywallModalOpenFromAskAI() {
      paywallModalOpenFromAskAIHost();
    },
    paywallModalOpenFromQuotaExceeded() {
      paywallModalOpenFromQuotaExceededHost();
    },
    paywallModalOpenFromAccountToPro() {
      paywallModalOpenFromAccountToProHost();
    },
    paywallModalOpenFromSessionHeader() {
      paywallModalOpenFromSessionHeaderHost();
    },
    paywallModalOpenFromSidebar() {
      paywallModalOpenFromSidebarHost();
    },
    paywallModalOpenFromNoTeamMemberPage() {
      paywallModalOpenFromNoTeamMemberPageHost();
    },
    trackPaywallViewed(input: { source: PaywallSource; target_plan: SubscriptionTier }) {
      trackPaywallViewedHost(input);
    },
    paywallCheckoutClickedFromUpgrade() {
      paywallCheckoutClickedFromUpgradeHost();
    },
    paywallCheckoutClickedFromFreeToPaid() {
      paywallCheckoutClickedFromFreeToPaidHost();
    },
    trackFindReplaceModalOpened() {
      trackFindReplaceModalOpenedHost();
    },
    trackFindReplaceScopeJustNoteSelected() {
      trackFindReplaceScopeJustNoteSelectedHost();
    },
    trackFindReplaceScopeAllTabsSelected() {
      trackFindReplaceScopeAllTabsSelectedHost();
    },
    trackFindReplaceScopeEverywhereSelected() {
      trackFindReplaceScopeEverywhereSelectedHost();
    },
    trackFindReplaceModalCancelled() {
      trackFindReplaceModalCancelledHost();
    },
    trackFindReplaceModalSubmitted() {
      trackFindReplaceModalSubmittedHost();
    },
    trackFindReplaceDocumentEdited({ sessionId }: { sessionId: string }) {
      trackFindReplaceDocumentEditedHost({ sessionId });
    },
    trackUserSettingsDateFormatChanged(dateFormat: DateFormat) {
      trackUserSettingsDateFormatChangedHost(dateFormat);
    },
    trackUserSettingsSpellingPreferenceChanged(spellingPreference: SpellingPreference) {
      trackUserSettingsSpellingPreferenceChangedHost(spellingPreference);
    },
    trackUserSettingsWordLibraryAdded(mappings: WordLibrary) {
      trackUserSettingsWordLibraryAddedHost(mappings);
    },

    trackBulkUploadReplacements(input: { count: number; from: 'editor' | 'settings' }) {
      trackBulkUploadReplacementsHost(input);
    },

    // New trackEventV2 implementations

    /**
     * Track web dictation started event (recording has begun)
     */
    trackDictationStarted(props: DictationStartedEventProps) {
      dispatch.analyticsScribe.trackEventV2({
        event_name: TrackingEventName.DictationStarted,
        props,
      });
    },

    /**
     * Track web dictation completed event (transcription + insertion both succeeded)
     */
    trackDictationCompleted(props: DictationCompletedEventProps) {
      dispatch.analyticsScribe.trackEventV2({
        event_name: TrackingEventName.DictationCompleted,
        props,
      });
    },

    /**
     * Track web dictation errored event (a level=ERROR transition during dictation lifecycle)
     */
    trackDictationErrored(props: DictationErroredEventProps) {
      dispatch.analyticsScribe.trackEventV2({
        event_name: TrackingEventName.DictationErrored,
        props,
      });
    },

    /**
     * Track legacy inline dictation completed event (legacy dictation in TipTap editor)
     * @param props - Legacy inline dictation event properties
     */
    trackLegacyInlineDictationCompleted(props: LegacyInlineDictationCompletedEventProps) {
      trackLegacyInlineDictationCompletedHost(props);
    },

    /**
     * Track dictation CSAT popover viewed event
     */
    trackDictationCsatViewed() {
      dispatch.analyticsScribe.trackEventV2({
        options: { amplitude: false },
        event_name: TrackingEventName.SurveyViewed,
        props: { view_action: 'universal_dictation_csat_shown' },
      });
    },

    /**
     * Track dictation CSAT feedback submitted
     */
    trackDictationCsatSubmitted(props: DictationCsatSubmittedEventProps) {
      dispatch.analyticsScribe.trackEventV2({
        options: { amplitude: false },
        event_name: TrackingEventName.DictationCsatSubmitted,
        props,
      });
    },

    /**
     * Track dictation CSAT popover dismissed without submitting
     */
    trackDictationCsatDismissed(props: DictationCsatDismissedEventProps) {
      dispatch.analyticsScribe.trackEventV2({
        options: { amplitude: false },
        event_name: TrackingEventName.DictationCsatDismissed,
        props,
      });
    },
    trackDocumentGenerated(props: DocumentEventProps) {
      trackDocumentGeneratedHost(props);
    },

    /**
     * @deprecated Use documentExported with format: 'print'
     *
     * Alias only: prints land as `document_exported` with `format: 'print'`.
     * No `document_printed` name exists anywhere. Query them with
     * `@action.target.name:document_exported @context.format:print`.
     */
    documentPrintedV2({
      sessionId,
      documentId,
      export_context,
      is_pinned_template,
      is_starter_pack_template,
      settingsPipeline,
      copySettings,
    }: {
      sessionId: string;
      documentId?: string;
      export_context?: DocumentExportContext;
      is_pinned_template: boolean;
      is_starter_pack_template: boolean;
      settingsPipeline?: SettingsPipeline;
      copySettings?: CopySettingsSnapshot;
    }) {
      documentPrintedV2Host({
        sessionId,
        documentId,
        export_context,
        is_pinned_template,
        is_starter_pack_template,
        settingsPipeline,
        copySettings,
      });
    },
    snippetsUploadedV2({ count, source }: { count: number; source: UploadSource }) {
      snippetsUploadedV2Host({ count, source });
    },

    /**
     * Track replacements (word library) bulk upload event
     * @param count - Number of replacements uploaded
     * @param source - Source of the upload (editor or settings)
     */
    replacementsUploadedV2({ count, source }: { count: number; source: UploadSource }) {
      replacementsUploadedV2Host({ count, source });
    },
    demoJoinFree() {
      dispatch.analyticsScribe.trackEvent({
        name: SegmentObjectName.ProductTour,
        props: {
          action: SegmentActionName.DemoJoinFree,
        },
      });
    },
    demoJoinPremium() {
      dispatch.analyticsScribe.trackEvent({
        name: SegmentObjectName.ProductTour,
        props: {
          action: SegmentActionName.DemoJoinPremium,
        },
      });
    },
    demoBindOnboardingInfo(sessionId?: string) {
      pushGtmDataLayerEvent({ event: 'signup_successful' });

      // Enhanced attribution: sessionStorage survives OAuth redirects and captures
      // click IDs (gclid/fbclid/…) beyond the current URL query string.
      const attributionParams = getUtmParams();
      // Original landing URL captured when the user first arrived with UTM params
      const landingUrl = getLandingUrl();

      dispatch.analyticsScribe.trackEvent({
        name: SegmentObjectName.ProductTour,
        props: {
          action: SegmentActionName.DemoBindUserToOnboardingInfo,
          custom_utm_source: attributionParams.utm_source,
          sessionId,
          // Include all attribution params for easier querying
          ...attributionParams,
        },
        // Override page URL with the original landing URL to preserve UTM/click IDs after OAuth redirects
        pageUrl: landingUrl,
      });

      dispatch.analyticsScribe.trackEventV2({
        options: { amplitude: false },
        event_name: TrackingEventName.AuthenticationCompleted,
        props: {
          authentication_flow: AuthenticationFlow.SIGN_UP,
          provider: mapAuthProviderToProvider(store.getState().auth?.authProvider),
          custom_utm_source: attributionParams.utm_source,
          ...attributionParams,
          onboarding_variant: GET_ONBOARDING_V2_VARIANT(),
        },
        // Override page URL with the original landing URL to preserve UTM/click IDs after OAuth redirects
        pageUrl: landingUrl,
      });

      // V2 — product_tour_viewed
      dispatch.analyticsScribe.trackEventV2({
        options: { amplitude: false },
        event_name: TrackingEventName.ProductTourViewed,
        props: {
          tour_action: 'bind_user_to_onboarding_info',
        },
      });
    },
    demoClickEmail() {
      dispatch.analyticsScribe.trackEvent({
        name: SegmentObjectName.ProductTour,
        props: {
          action: SegmentActionName.DemoClickEmail,
        },
      });
    },
    demoClickGmail() {
      dispatch.analyticsScribe.trackEvent({
        name: SegmentObjectName.ProductTour,
        props: {
          action: SegmentActionName.DemoClickGmail,
        },
      });
    },
    trackTemplateDeleted(templateId: string) {
      trackTemplateDeletedHost(templateId);
    },
    trackTemplateEdited({
      templateId,
      templateVisibility,
    }: {
      templateId: string;
      templateVisibility: TemplateVisibility;
    }) {
      trackTemplateEditedHost({ templateId, templateVisibility });
    },
    trackTemplateLibrarySearched(searchText: string) {
      trackTemplateLibrarySearchedHost(searchText);
    },
    trackTemplateLibraryFilteredApplied(filter: string) {
      trackTemplateLibraryFilteredAppliedHost(filter);
    },
    trackTemplateLibraryViewed() {
      trackTemplateLibraryViewedHost();
    },
    trackTemplateLibrarySortApplied(sort: string) {
      trackTemplateLibrarySortAppliedHost(sort);
    },
    trackTemplateFavourited({
      templateId,
      templateType,
      templateFavourited,
    }: {
      templateId: string;
      templateType: TemplateVisibility;
      templateFavourited: boolean;
    }) {
      trackTemplateFavouritedHost({ templateId, templateType, templateFavourited });
    },
    trackTemplatePinned({
      templateId,
      templateType,
      templatePinned,
      queueSource,
      currentQueueSize,
    }: {
      templateId: string;
      templateType: TemplateVisibility;
      templatePinned: boolean;
      /** Surface that triggered the pin/queue toggle. */
      queueSource?: TemplateQueueSource;
      /** Queue size after this change. */
      currentQueueSize?: number;
    }) {
      trackTemplatePinnedHost({
        templateId,
        templateType,
        templatePinned,
        queueSource,
        currentQueueSize,
      });
    },
    trackDocumentTemplateQueueLimitReached(
      input: DocumentTemplateQueueLimitReachedEventProps
    ) {
      trackDocumentTemplateQueueLimitReachedHost(input);
    },
    trackDocumentTemplateQueueReordered(input: DocumentTemplateQueueReorderedEventProps) {
      trackDocumentTemplateQueueReorderedHost(input);
    },
    trackSessionStartedWithDocumentQueue(
      input: SessionStartedWithDocumentQueueEventProps
    ) {
      trackSessionStartedWithDocumentQueueHost(input);
    },

    trackQueuedDocumentGenerationStarted(
      input: QueuedDocumentGenerationStartedEventProps
    ) {
      trackQueuedDocumentGenerationStartedHost(input);
    },

    trackQueuedDocumentGenerationFailed(input: QueuedDocumentGenerationFailedEventProps) {
      trackQueuedDocumentGenerationFailedHost(input);
    },
    trackQueuedDocumentGenerationCancelled(
      input: QueuedDocumentGenerationCancelledEventProps
    ) {
      trackQueuedDocumentGenerationCancelledHost(input);
    },
    trackQueuedDocumentTabTemplateSwapped(
      input: QueuedDocumentTabTemplateSwappedEventProps
    ) {
      trackQueuedDocumentTabTemplateSwappedHost(input);
    },
    trackIntegrationStarted(input: IntegrationStartedEventProps) {
      trackIntegrationStartedHost(input);
    },
    trackIntegrationFailed(input: IntegrationFailedEventProps) {
      trackIntegrationFailedHost(input);
    },
    trackIntegrationUserSearched(input: IntegrationUserSearchedEventProps) {
      dispatch.analyticsScribe.trackEventV2({
        options: { amplitude: false },
        event_name: TrackingEventName.IntegrationUserSearched,
        props: input,
      });
    },
    trackConnectIntegration(userInfo: CreateEHRProfileRequest) {
      trackConnectIntegrationHost(userInfo);
    },
    trackPatientSelected(input: PatientSelectedEventProps) {
      trackPatientSelectedHost(input);
    },

    // team

    trackTeamCreate(input: { teamName: string; teamId: string }) {
      trackTeamCreateHost(input);
    },
    trackTeamUpdated(input: { teamId: string; teamName: string }) {
      trackTeamUpdatedHost(input);
    },
    trackSendTeamInvitation({
      teamId,
      email,
      teamName,
      teamLink,
      totalEmailCount,
      source,
    }: {
      teamId: string;
      email: string;
      teamName: string;
      teamLink?: string;
      totalEmailCount?: number;
      source?: TeamInviteSource;
    }) {
      trackSendTeamInvitationHost({
        teamId,
        email,
        teamName,
        teamLink,
        totalEmailCount,
        source,
      });
    },
    trackResendTeamInvitation(input: { teamId: string; email: string }) {
      trackResendTeamInvitationHost(input);
    },
    trackDeleteTeamMember(input: {
      teamId: string;
      memberId: string;
      memberEmail: string;
    }) {
      trackDeleteTeamMemberHost(input);
    },
    trackDeleteTeam(input: { teamId: string }) {
      trackDeleteTeamHost(input);
    },

    trackAcceptTeamInvitation(input: { teamId: string; invitedEmail: string }) {
      trackAcceptTeamInvitationHost(input);
    },
    trackTeamBillingClicked(teamId: string) {
      trackTeamBillingClickedHost(teamId);
    },

    trackUserJoinTeamSuccess(input: {
      teamId: string;
      invitedEmail: string;
      joinMethod?: string;
    }) {
      trackUserJoinTeamSuccessHost(input);
    },
    trackTeamMemberGuideVideoButtonClicked() {
      trackTeamMemberGuideVideoButtonClickedHost();
    },
    trackUseHeidiButtonClicked() {
      trackUseHeidiButtonClickedHost();
    },
    trackUpdateSpecialtyClicked() {
      trackUpdateSpecialtyClickedHost();
    },
    trackSelfOnboardingClicked() {
      trackSelfOnboardingClickedHost();
    },
    trackReferralLinkCreated() {
      trackReferralLinkCreatedHost();
    },
    trackReferralLinkCopied() {
      trackReferralLinkCopiedHost();
    },
    trackReferralModalOpened() {
      trackReferralModalOpenedHost();
    },

    trackOrganisationSurveyShown() {
      trackOrganisationSurveyShownHost();
    },

    trackOrganisationSurveyNameEntered(name: string) {
      trackOrganisationSurveyNameEnteredHost(name);
    },

    trackOrganisationSurveySizeSelected(size: OrganisationSize) {
      trackOrganisationSurveySizeSelectedHost(size);
    },

    trackOrganisationSurveyRoleSelected(role: OrganisationRole) {
      trackOrganisationSurveyRoleSelectedHost(role);
    },

    trackOrganisationSurveyEhrProviderSelected(provider: EHRProvider) {
      trackOrganisationSurveyEhrProviderSelectedHost(provider);
    },

    trackOrganisationSurveySubmitted(input: {
      name: string;
      size?: OrganisationSize;
      role?: OrganisationRole;
      ehrProvider?: EHRProvider;
      specialtyId?: string;
      specialtyName?: string;
      otherSpecialty?: string;
      isOfficialPractice?: boolean;
      cqcPracticeId?: string;
    }) {
      trackOrganisationSurveySubmittedHost(input);
    },

    trackOnboardingCompleted(input?: { onboardingVariant?: OnboardingV2Variant }) {
      trackOnboardingCompletedHost(input);
    },

    trackSignUpFormCompleted(input: { authenticationProvider: AuthenticationProvider }) {
      trackSignUpFormCompletedHost(input);
    },
    trackDeleteAccountSuccess(input: {
      userId?: string;
      reason?: string;
      details?: string;
    }) {
      trackDeleteAccountSuccessHost(input);
    },
    integrationReadyModalClosed(input: { stay?: boolean }) {
      integrationReadyModalClosedHost(input);
    },
    trackToggleTeamMfa(input: { teamId: string; enabled: boolean; adminId?: string }) {
      trackToggleTeamMfaHost(input);
    },
    trackToggleTeamConsent(input: {
      teamId: string;
      enabled: boolean;
      adminId?: string;
    }) {
      trackToggleTeamConsentHost(input);
    },
    trackUpdateTeamCustomConsentText(input: {
      teamId: string;
      adminId?: string;
      hasCustomText: boolean;
    }) {
      trackUpdateTeamCustomConsentTextHost(input);
    },
    trackTeamEvidenceAccessUpdated(props: TeamEvidenceAccessUpdatedEventProps) {
      trackTeamEvidenceAccessUpdatedHost(props);
    },
    trackTeamHeidiIiAccessUpdated(props: TeamHeidiIiAccessUpdatedEventProps) {
      trackTeamHeidiIiAccessUpdatedHost(props);
    },
    trackToggleUserMfa(input: { enabled: boolean }) {
      trackToggleUserMfaHost(input);
    },
    trackCommunityTemplateViewed(input: { templateId: string }) {
      trackCommunityTemplateViewedHost(input);
    },
    trackCommunityTemplateImported(input: { templateId: string }) {
      trackCommunityTemplateImportedHost(input);
    },
    trackCommunityTemplatePublished(input: { templateId: string }) {
      trackCommunityTemplatePublishedHost(input);
    },
    trackCommunityTemplateSearched(input: { search: string }) {
      trackCommunityTemplateSearchedHost(input);
    },
    trackCommunityTemplateLiked(input: { templateId: string }) {
      trackCommunityTemplateLikedHost(input);
    },
    trackCommunityTemplateUnliked(input: { templateId: string }) {
      trackCommunityTemplateUnlikedHost(input);
    },

    trackNativeAuthenticated() {
      trackNativeAuthenticatedHost();
    },
    trackTauriErrorEvent(payload?: TauriErrorEventPayload) {
      trackTauriErrorEventHost(payload);
    },

    trackTauriUpdate(version?: string) {
      trackTauriUpdateHost(version);
    },

    trackTauriRelaunch() {
      trackTauriRelaunchHost();
    },

    trackTauriFailedToRelaunch(error: string) {
      trackTauriFailedToRelaunchHost(error);
    },

    trackTauriStopRecordingPreventedAsRecordingStillInitializing() {
      trackTauriStopRecordingPreventedAsRecordingStillInitializingHost();
    },

    /** Desktop stop exhausted every native stop; a blocking failure was shown. */
    trackTauriStopFailedSurfaced(input: {
      sessionId: string;
      path: RecordingStopFailedPath;
      attempts: number;
    }) {
      trackTauriStopFailedSurfacedHost(input);
    },
    trackSnippetCreated(input: {
      contentLength: number;
      shorthandLength: number;
      from: 'editor' | 'settings' | 'dictation';
    }) {
      trackSnippetCreatedHost(input);
    },
    trackSnippetEdited(input: {
      snippetId: string;
      contentLength: number;
      shorthandLength: number;
      from: 'editor' | 'settings' | 'dictation';
    }) {
      trackSnippetEditedHost(input);
    },
    trackSnippetDeleted(input: {
      snippetId: string;
      from: 'editor' | 'settings' | 'dictation';
    }) {
      trackSnippetDeletedHost(input);
    },
    trackSnippetUsed(input: {
      snippetId: string;
      contentLength: number;
      shorthandLength: number;
    }) {
      trackSnippetUsedHost(input);
    },
    trackSnippetOpenPrompt() {
      trackSnippetOpenPromptHost();
    },
    trackShortcutUsed({ shortcutName }: { shortcutName: ShortcutContext }) {
      trackShortcutUsedHost({ shortcutName });
    },
    trackPatientLinked(input: PatientLinkedEventProps) {
      trackPatientLinkedHost(input);
    },

    // Patient search keystroke event for the find-or-link funnel.
    // Never receives the raw query string — clinicians type patient names
    // into this field, so the v2-0-0 schema drops `query` in favour of
    // `query_length` for HIPAA. See PatientSearchedEventProps.
    trackPatientSearched(input: PatientSearchedEventProps) {
      dispatch.analyticsScribe.trackEventV2({
        options: { amplitude: false },
        event_name: TrackingEventName.PatientSearched,
        props: input,
      });
    },
    trackPatientUnlinked(input: PatientUnlinkedEventProps) {
      trackPatientUnlinkedHost(input);
    },

    trackPatientRecapSourceSessionClicked(
      input: PatientRecapSourceSessionClickedEventProps
    ) {
      dispatch.analyticsScribe.trackEventV2({
        event_name: TrackingEventName.PatientRecapSourceSessionClicked,
        props: input,
      });
    },
    trackCreatePatientProfile(input: { isFromEHR: boolean }) {
      trackCreatePatientProfileHost(input);
    },

    trackDefaultDeviceErrorTauri() {
      trackDefaultDeviceErrorTauriHost();
    },
    trackGetCurrentRecordingFailed({ speakerSize, audioSize }) {
      trackGetCurrentRecordingFailedHost({ speakerSize, audioSize });
    },
    trackNotificationPreferencesSavedFromModal({
      isSessionExpiringNotificationEnabled,
      isInmailNotificationEnabled,
    }: {
      isSessionExpiringNotificationEnabled: boolean;
      isInmailNotificationEnabled: boolean;
    }) {
      trackNotificationPreferencesSavedFromModalHost({
        isSessionExpiringNotificationEnabled,
        isInmailNotificationEnabled,
      });
    },
    trackTokenGenerated(input: TokenGeneratedEventProps) {
      trackTokenGeneratedHost(input);
    },
    trackHaikuTabChanged(input: HaikuTabChangedEventProps) {
      trackHaikuTabChangedHost(input);
    },
    sectionalNoteEhrSectionSelected({
      isUnlinking,
      heidiSectionTitle,
      ehrSectionTitle,
    }: {
      isUnlinking?: boolean;
      heidiSectionTitle?: string;
      ehrSectionTitle?: string;
    }) {
      sectionalNoteEhrSectionSelectedHost({
        isUnlinking,
        heidiSectionTitle,
        ehrSectionTitle,
      });
    },

    userHasMedicalDirector(input: {
      authID: string;
      userTraits: {
        ehr_provider: Maybe<EHRProvider>;
        from?: Maybe<string>;
      };
    }) {
      userHasMedicalDirectorHost(input);
    },

    trackMedicalDirectorGetPatientSessionsFailed(error: string) {
      trackMedicalDirectorGetPatientSessionsFailedHost(error);
    },

    trackMedicalDirectorSyncSessionsFailed(error: string) {
      trackMedicalDirectorSyncSessionsFailedHost(error);
    },
    trackMedicalDirectorGetDemographicsFailed(error: string) {
      trackMedicalDirectorGetDemographicsFailedHost(error);
    },
    trackGettingStartedPanelOpened() {
      trackGettingStartedPanelOpenedHost();
    },
    trackGettingStartedPanelClosed() {
      trackGettingStartedPanelClosedHost();
    },
    trackGettingStartedPanelNextStep(step: string) {
      trackGettingStartedPanelNextStepHost(step);
    },
    trackGettingStartedPanelOpenReferralModal() {
      trackGettingStartedPanelOpenReferralModalHost();
    },
    trackGettingStartedCompleted() {
      trackGettingStartedCompletedHost();
    },
    uploadContextSingleFile(fileSize: number) {
      uploadContextSingleFileHost(fileSize);
    },
    uploadContextFileFailed(fileSize: number) {
      uploadContextFileFailedHost(fileSize);
    },
    uploadContextFileSuccess(fileSize: number) {
      uploadContextFileSuccessHost(fileSize);
    },
    uploadContextFiles(fileSize: number) {
      uploadContextFilesHost(fileSize);
    },
    saveContextFilesUpdates() {
      saveContextFilesUpdatesHost();
    },
    deleteContextFiles(filesAmount: number) {
      deleteContextFilesHost(filesAmount);
    },
    markSessionAsContextOnly(sessionId?: string) {
      markSessionAsContextOnlyHost(sessionId);
    },
    trackFailedToSendChunk(input: {
      sessionId: string;
      recordingId: string;
      chunkId: number;
    }) {
      trackFailedToSendChunkHost(input);
    },
    trackChunkSessionMismatch(input: { currentSessionId: string; newSessionId: string }) {
      trackChunkSessionMismatchHost(input);
    },
    trackBackupSizeZeroError(input: { sessionId: string }) {
      trackBackupSizeZeroErrorHost(input);
    },
    trackMediaRecorderUnableToStop() {
      trackMediaRecorderUnableToStopHost();
    },
    widgetLinkAccountUnlinkSwitch(params: { integrationName?: string }) {
      widgetLinkAccountUnlinkSwitchHost(params);
    },
    widgetLinkAccountStartTrialClicked(params: { integrationName?: string }) {
      widgetLinkAccountStartTrialClickedHost(params);
    },
    widgetLinkHeidiAccountAlreadyLinkedToEhr(params: { integrationName?: string }) {
      widgetLinkHeidiAccountAlreadyLinkedToEhrHost(params);
    },
    widgetLinkEhrAccountAlreadyLinkedToHeidi(params: { integrationName?: string }) {
      widgetLinkEhrAccountAlreadyLinkedToHeidiHost(params);
    },
    tauriSessionMismatch() {
      tauriSessionMismatchHost();
    },
    trialToPaidModalOpened(params: {
      location: 'cta-button' | 'account-form' | 'quota-reminder';
    }) {
      trialToPaidModalOpenedHost(params);
    },
    trialToPaidModalPeriodChanged(input: { period: Period }) {
      trialToPaidModalPeriodChangedHost(input);
    },
    trialToPaidModalClosed() {
      trialToPaidModalClosedHost();
    },
    trialToPaidModalUpgradeClicked(input: { period: Period }) {
      trialToPaidModalUpgradeClickedHost(input);
    },
    endTrialModalOpened() {
      endTrialModalOpenedHost();
    },
    endTrialModalPeriodChanged(input: { period: Period }) {
      endTrialModalPeriodChangedHost(input);
    },
    endTrialModalClosed() {
      endTrialModalClosedHost();
    },
    endTrialModalUpgradeClicked(input: { period: Period }) {
      endTrialModalUpgradeClickedHost(input);
    },
    endTrialModalDowngradeClicked() {
      endTrialModalDowngradeClickedHost();
    },
    extendTrialModalOpened() {
      extendTrialModalOpenedHost();
    },
    extendTrialModalBackClicked(input: { selectedHours: number }) {
      extendTrialModalBackClickedHost(input);
    },
    extendTrialModalExtendClicked(input: { selectedHours: number }) {
      extendTrialModalExtendClickedHost(input);
    },

    trackFailedToStartChunkRecording(error?: string) {
      trackFailedToStartChunkRecordingHost(error);
    },
    trackMediaRecorderFailedToStart(input: {
      sessionId: string;
      recordingId: string;
      chunkCount: number;
      error: string;
    }) {
      trackMediaRecorderFailedToStartHost(input);
    },
    trackMediaStreamChunkTrackStateError(input: { error: string }) {
      trackMediaStreamChunkTrackStateErrorHost(input);
    },

    extensionSetToken() {
      dispatch.analyticsScribe.trackEvent({
        name: SegmentObjectName.ChromeExtension,
        props: {
          action: SegmentActionName.ExtensionSetToken,
        },
      });

      // V2 — authentication_completed (chrome extension)
      dispatch.analyticsScribe.trackEventV2({
        options: { amplitude: false },
        event_name: TrackingEventName.AuthenticationCompleted,
        props: {
          authentication_flow: AuthenticationFlow.LOGIN,
          provider: mapAuthProviderToProvider(store.getState().auth?.authProvider),
        },
      });
    },
    trackRecordingTriesToStartWhenStatusIsRecording() {
      trackRecordingTriesToStartWhenStatusIsRecordingHost();
    },
    trackTaskEvent(input: {
      taskEventType: TaskEventType;
      sessionId?: string;
      task: ClinicalTask;
    }) {
      trackTaskEventHost(input);
    },
    trackTaskStatefulEvent(input: {
      taskEventType: TaskEventType;
      prevTask: Partial<ClinicalTask>;
      nextTask: Partial<ClinicalTask>;
    }) {
      trackTaskStatefulEventHost(input);
    },
    trackClinicalTaskPanelToggle(input: { opened: boolean; from: 'session' | 'x' }) {
      trackClinicalTaskPanelToggleHost(input);
    },
    trackTaskViewedEvent(input: {
      task_id?: string;
      session_id?: string;
      view_context: 'task_detail' | 'in_session_card';
    }) {
      trackTaskViewedEventHost(input);
    },
    trackTaskListViewedEvent(input: {
      session_id?: string;
      filter_status?: string;
      filter_assignee_id?: string;
      sort_by?: string;
    }) {
      trackTaskListViewedEventHost(input);
    },
    trackTaskNotificationClickedEvent(input: {
      task_id?: string;
      session_id?: string;
      notification_type: 'assigned' | 'due_soon' | 'overdue';
    }) {
      trackTaskNotificationClickedEventHost(input);
    },
    reachedAudioLevelDuringRecording({ sessionId, audioLevel }) {
      reachedAudioLevelDuringRecordingHost({ sessionId, audioLevel });
    },

    trackCodingSidebarOpened(input: {
      sessionId: string;
      noteId: string;
      kindeUserId: string;
      codesetsEnabled: string[];
      totalCodesAvailable: number;
    }) {
      trackCodingSidebarOpenedHost(input);
    },

    trackClinicalCodeCopied(input: {
      sessionId: string;
      noteId: string;
      kindeUserId: string;
      code: string;
      codeSystem: CodeSystem;
      relevance: CodedClinicalEntityRelevance;
      relevanceScore: number;
    }) {
      trackClinicalCodeCopiedHost(input);
    },
    trackCreateNoteOrDocumentClicked() {
      trackCreateNoteOrDocumentClickedHost();
    },
    trackFormFillCreateTemplateClicked() {
      trackFormFillCreateTemplateClickedHost();
    },

    trackSidenavCreateTemplateDropdownOpened() {
      dispatch.analyticsScribe.trackEventV2({
        event_name: TrackingEventName.ButtonClicked,
        props: {
          screen_name: ScreenName.Sidenav,
          action: ButtonAction.SidenavCreateTemplateDropdownOpened,
          label: 'Create template dropdown',
        },
      });
    },

    trackSidenavCreateNoteTemplateClicked() {
      dispatch.analyticsScribe.trackEventV2({
        event_name: TrackingEventName.ButtonClicked,
        props: {
          screen_name: ScreenName.Sidenav,
          action: ButtonAction.SidenavCreateNoteTemplateClicked,
          label: 'Note template',
        },
      });
    },

    trackSidenavCreateDocumentTemplateClicked() {
      dispatch.analyticsScribe.trackEventV2({
        event_name: TrackingEventName.ButtonClicked,
        props: {
          screen_name: ScreenName.Sidenav,
          action: ButtonAction.SidenavCreateDocumentTemplateClicked,
          label: 'Document template',
        },
      });
    },

    trackSidenavCreateAutoPdfTemplateClicked() {
      dispatch.analyticsScribe.trackEventV2({
        event_name: TrackingEventName.ButtonClicked,
        props: {
          screen_name: ScreenName.Sidenav,
          action: ButtonAction.SidenavCreateAutoPdfTemplateClicked,
          label: 'Auto-PDF template',
        },
      });
    },
    trackFormFillHelpArticleClicked() {
      trackFormFillHelpArticleClickedHost();
    },
    trackFormFillUploadClicked() {
      trackFormFillUploadClickedHost();
    },
    trackFormLibraryViewed() {
      trackFormLibraryViewedHost();
    },
    trackPyneOnboardingRendered(input: { region: string }) {
      trackPyneOnboardingRenderedHost(input);
    },
    trackPersonalizationTurnedOff(from?: 'note' | 'document' | 'opt_in_panel') {
      trackPersonalizationTurnedOffHost(from);
    },
    trackPersonalizationTurnedOn(from?: 'note' | 'document' | 'opt_in_panel') {
      trackPersonalizationTurnedOnHost(from);
    },

    trackTabSharingDoNoShowMessageAgain() {
      trackTabSharingDoNoShowMessageAgainHost();
    },

    trackTabSharingNotAvailableModalShown() {
      trackTabSharingNotAvailableModalShownHost();
    },
    trackScribeStyleUpdated(input: {
      sessionId: string;
      brain: Brain;
      oldBrain?: Brain;
      tabType: 'note' | 'document';
      isRegenerate?: boolean;
    }) {
      trackScribeStyleUpdatedHost(input);
    },
    trackVoiceStyleUpdated(input: {
      sessionId: string;
      voiceStyle: VoiceStyle;
      oldVoiceStyle?: VoiceStyle;
      tabType: 'note' | 'document';
      isRegenerate?: boolean;
    }) {
      trackVoiceStyleUpdatedHost(input);
    },
    trackNhsTemplateComplianceBlock(props?: NHSTemplateComplianceDetailedProps) {
      trackNhsTemplateComplianceBlockHost(props);
    },
    trackNhsTemplateComplianceWarning(props?: NHSTemplateComplianceDetailedProps) {
      trackNhsTemplateComplianceWarningHost(props);
    },
    trackAskHeidiComplianceBlock(props?: NHSAskHeidiComplianceDetailedProps) {
      trackAskHeidiComplianceBlockHost(props);
    },

    // Chat
    trackChatActivityTimelineOpened(input: { sessionId: string }) {
      dispatch.analyticsScribe.trackEvent({
        name: SegmentObjectName.Chat,
        props: {
          action: SegmentActionName.ChatActivityTimelineOpened,
          sessionId: input.sessionId,
        },
      });
      // V2 — Amplitude migration (chatActivityTimelineOpened -> panel_opened)
      dispatch.analyticsScribe.trackEventV2({
        options: { amplitude: false },
        event_name: TrackingEventName.PanelOpened,
        props: {
          panel_type: 'chat_activity_timeline',
          trigger: 'manual',
          session_id: input.sessionId,
        },
      });
    },

    trackChatActivityTimelineClosed(input: { sessionId: string }) {
      dispatch.analyticsScribe.trackEvent({
        name: SegmentObjectName.Chat,
        props: {
          action: SegmentActionName.ChatActivityTimelineClosed,
          sessionId: input.sessionId,
        },
      });
      // V2 — Amplitude migration (chatActivityTimelineClosed -> panel_closed)
      dispatch.analyticsScribe.trackEventV2({
        options: { amplitude: false },
        event_name: TrackingEventName.PanelClosed,
        props: {
          panel_type: 'chat_activity_timeline',
          trigger: 'manual',
          session_id: input.sessionId,
        },
      });
    },

    trackChatMessageSubmitted(input: {
      sessionId: string;
      mode: string;
      message_length: number;
    }) {
      trackChatMessageSubmittedHost(input);
    },

    trackChatStreamInterrupted(input: { sessionId: string; messageId?: string }) {
      trackChatStreamInterruptedHost(input);
    },

    trackChatModeToggled(input: {
      sessionId: string;
      previous_mode: string;
      new_mode: string;
    }) {
      trackChatModeToggledHost(input);
    },
    trackEvidenceSidebarClicked(input: EvidenceSidebarClickedEventProps) {
      trackEvidenceSidebarClickedHost(input);
    },
    trackEvidenceSourcesListClicked(input: EvidenceSourcesListClickedEventProps) {
      trackEvidenceSourcesListClickedHost(input);
    },
    trackEvidenceSourcesListPresetClicked(
      input: EvidenceSourcesListPresetClickedEventProps
    ) {
      trackEvidenceSourcesListPresetClickedHost(input);
    },
    trackEvidenceSourcesListCustomClicked(
      input: EvidenceSourcesListCustomClickedEventProps
    ) {
      trackEvidenceSourcesListCustomClickedHost(input);
    },
    trackEvidenceSourcesListLocalGuidelinesClicked(
      input: EvidenceSourcesListLocalGuidelinesClickedEventProps
    ) {
      trackEvidenceSourcesListLocalGuidelinesClickedHost(input);
    },
    trackEvidenceSourcesListWebSearchClicked(
      input: EvidenceSourcesListWebSearchClickedEventProps
    ) {
      trackEvidenceSourcesListWebSearchClickedHost(input);
    },

    /** Delegates to the live Evidence submit host (no `evidence_chat_*` dual-write). */
    trackEvidenceChatSubmitted(input: EvidenceChatSubmittedEventProps) {
      trackEvidenceChatSubmittedHost(input);
    },

    /** Delegates to the live Evidence completed host (no `evidence_chat_*` dual-write). */
    trackEvidenceChatCompleted(input: EvidenceChatCompletedEventProps) {
      trackEvidenceChatCompletedHost(input);
    },
    trackEvidenceChatError(input: EvidenceChatErrorEventProps) {
      trackEvidenceChatErrorHost(input);
    },
    trackEvidenceChatAborted(input: EvidenceChatAbortedEventProps) {
      trackEvidenceChatAbortedHost(input);
    },
    trackEvidenceProTrialButtonStarted(input: EvidenceProTrialButtonStartedEventProps) {
      trackEvidenceProTrialButtonStartedHost(input);
    },
    trackEvidenceDeepLinkSignInClicked(input: EvidenceDeepLinkSignInClickedEventProps) {
      trackEvidenceDeepLinkSignInClickedHost(input);
    },
    trackEvidenceDeepLinkSignUpClicked(input: EvidenceDeepLinkSignUpClickedEventProps) {
      trackEvidenceDeepLinkSignUpClickedHost(input);
    },
    trackEvidenceNewChatClicked(input: EvidenceNewChatClickedEventProps) {
      trackEvidenceNewChatClickedHost(input);
    },
    trackEvidenceDeleteChatClicked(input: EvidenceDeleteChatClickedEventProps) {
      trackEvidenceDeleteChatClickedHost(input);
    },
    trackEvidenceSaveChatClicked(input: EvidenceSaveChatClickedEventProps) {
      trackEvidenceSaveChatClickedHost(input);
    },
    trackEvidenceUnsaveChatClicked(input: EvidenceUnsaveChatClickedEventProps) {
      trackEvidenceUnsaveChatClickedHost(input);
    },
    trackEvidenceClickPastSessionClicked(
      input: EvidenceClickPastSessionClickedEventProps
    ) {
      trackEvidenceClickPastSessionClickedHost(input);
    },
    trackChatCreated(input: ChatCreatedEventProps) {
      trackChatCreatedHost(input);
    },
    trackChatViewed(input: ChatViewedEventProps) {
      trackChatViewedHost(input);
    },
    trackChatDeleted(input: ChatDeletedEventProps) {
      trackChatDeletedHost(input);
    },
    trackEvidenceChatSidebarOpen(input: EvidenceChatSidebarOpenEventProps) {
      trackEvidenceChatSidebarOpenHost(input);
    },
    trackEvidenceChatSidebarClose(input: EvidenceChatSidebarCloseEventProps) {
      trackEvidenceChatSidebarCloseHost(input);
    },
    trackEvidenceToastShown(input: EvidenceToastShownEventProps) {
      trackEvidenceToastShownHost(input);
    },
    trackEvidenceToastViewClicked(input: EvidenceToastViewClickedEventProps) {
      trackEvidenceToastViewClickedHost(input);
    },
    trackEvidenceLanguageChanged(input: EvidenceLanguageChangedEventProps) {
      trackEvidenceLanguageChangedHost(input);
    },
    trackEvidenceSpecialtyChanged(input: EvidenceSpecialtyChangedEventProps) {
      trackEvidenceSpecialtyChangedHost(input);
    },
    trackEvidenceJurisdictionChanged(input: EvidenceJurisdictionChangedEventProps) {
      trackEvidenceJurisdictionChangedHost(input);
    },
    trackEvidenceOnboardingViewed(input: EvidenceOnboardingViewedEventProps) {
      trackEvidenceOnboardingViewedHost(input);
    },
    trackEvidenceOnboardingSaved(input: EvidenceOnboardingSavedEventProps) {
      trackEvidenceOnboardingSavedHost(input);
    },
    trackEvidenceOnboardingSkipped() {
      trackEvidenceOnboardingSkippedHost();
    },
    trackEvidenceOnboardingDismissed() {
      trackEvidenceOnboardingDismissedHost();
    },

    trackEvidenceNhsContactSalesSubmitted(
      input: EvidenceNhsContactSalesSubmittedEventProps
    ) {
      trackEvidenceNhsContactSalesSubmittedHost(input);
    },

    // Share Evidence Chat
    trackEvidenceShareModalOpened(input: EvidenceShareModalOpenedEventProps) {
      dispatch.analyticsScribe.trackEvent({
        name: SegmentObjectName.Evidence,
        props: {
          action: SegmentEvidenceActionName.EvidenceShareModalOpened,
          evidence_location: input.evidence_location,
          region: input.region,
          is_evidence_pro: input.is_evidence_pro,
          is_team_member: input.is_team_member,
          chat_id: input.chat_id,
        },
      });
    },

    trackEvidenceShareLinkCopied(input: EvidenceShareLinkCopiedEventProps) {
      dispatch.analyticsScribe.trackEvent({
        name: SegmentObjectName.Evidence,
        props: {
          action: SegmentEvidenceActionName.EvidenceShareLinkCopied,
          evidence_location: input.evidence_location,
          region: input.region,
          is_evidence_pro: input.is_evidence_pro,
          is_team_member: input.is_team_member,
          chat_id: input.chat_id,
        },
      });
    },

    trackEvidenceShareSocialClicked(input: EvidenceShareSocialClickedEventProps) {
      dispatch.analyticsScribe.trackEvent({
        name: SegmentObjectName.Evidence,
        props: {
          action: SegmentEvidenceActionName.EvidenceShareSocialClicked,
          evidence_location: input.evidence_location,
          region: input.region,
          is_evidence_pro: input.is_evidence_pro,
          is_team_member: input.is_team_member,
          chat_id: input.chat_id,
          platform: input.platform,
        },
      });
    },

    trackEvidenceSharedChatOpened(input: EvidenceSharedChatOpenedEventProps) {
      dispatch.analyticsScribe.trackEvent({
        name: SegmentObjectName.Evidence,
        props: {
          action: SegmentEvidenceActionName.EvidenceSharedChatOpened,
          share_token: input.share_token,
          is_authenticated: input.is_authenticated,
        },
      });
    },
    trackGlobalTemplateVisibilityChanged({
      templateId,
      changedBy,
      previousVisibility,
      visibility,
      sharedTeams,
    }: {
      templateId: string;
      changedBy?: OrganizationTemplateChangedBy;
      previousVisibility: TemplateVisibility;
      visibility: TemplateVisibility;
      sharedTeams?: string[];
    }) {
      trackGlobalTemplateVisibilityChangedHost({
        templateId,
        changedBy,
        previousVisibility,
        visibility,
        sharedTeams,
      });
    },
    trackGlobalTemplateDeleted(templateId: string) {
      trackGlobalTemplateDeletedHost(templateId);
    },
    trackGlobalTemplateCreated({
      templateId,
      visibility,
      sharedTeams,
    }: {
      templateId: string;
      visibility: TemplateVisibility;
      sharedTeams: string[];
    }) {
      trackGlobalTemplateCreatedHost({ templateId, visibility, sharedTeams });
    },

    // Force Update Analytics
    trackForceUpdateViewed(input: ForceUpdateViewedEventProps) {
      trackForceUpdateViewedHost(input);
    },

    trackForceUpdateDeferred(input: ForceUpdateDeferredEventProps) {
      trackForceUpdateDeferredHost(input);
    },

    trackForceUpdateInitiated(input: ForceUpdateInitiatedEventProps) {
      trackForceUpdateInitiatedHost(input);
    },
    trackBookDemoFormSubmitted(input: BookDemoFormSubmittedEventProps) {
      trackBookDemoFormSubmittedHost(input);
    },
    trackBookDemoCountrySelected(input: BookDemoCountrySelectedEventProps) {
      trackBookDemoCountrySelectedHost(input);
    },
    trackBookDemoCliniciansSelected(input: BookDemoCliniciansSelectedEventProps) {
      trackBookDemoCliniciansSelectedHost(input);
    },
    trackBookDemoNextClicked(input?: BookDemoNextClickedEventProps) {
      trackBookDemoNextClickedHost(input);
    },

    /**
     * Track note updated event
     * Fired when someone updates the text of their note
     * @see https://www.notion.so/heidihealth/note_updated-27fca630286e80faa219f26cb32be2f5
     */
    trackNoteUpdated(input: {
      session_id: string;
      template_id?: string | null;
      voice_style?: VoiceStyle | null;
      original_word_length?: number | null;
      current_word_length?: number | null;
      word_diff?: number | null;
      edit_rate?: number | null;
      /** Source of the note update: 'user' for manual edits, 'evidence' for Evidence chat content */
      source?: NoteUpdateSource;
      /** Type of update when source is 'evidence': 'add' for appending, 'replace' for replacing */
      update_type?: NoteUpdateType;
    }) {
      trackNoteUpdatedHost(input);
    },

    /**
     * Track document updated event
     * Fired when someone updates the text of their document
     */
    trackDocumentUpdated(input: {
      update_type: 'text';
      document_id: string;
      session_id: string;
      template_id?: string;
      voice_style?: VoiceStyle;
      original_word_length: number;
      current_word_length: number;
      word_diff: number;
      edit_rate: number;
    }) {
      dispatch.analyticsScribe.trackEventV2({
        options: { amplitude: false },
        event_name: TrackingEventName.DocumentUpdated,
        props: input,
      });
    },
    trackIntegrationCreated(input: IntegrationCreatedEventProps) {
      trackIntegrationCreatedHost(input);
    },

    /**
     * Track integration updated event
     * Fired when an integration configuration is updated
     */
    trackIntegrationUpdated(input: IntegrationUpdatedEventProps) {
      dispatch.analyticsScribe.trackEventV2({
        options: { amplitude: false },
        event_name: TrackingEventName.IntegrationUpdated,
        props: input,
      });
    },

    /**
     * Track integration data completed event
     * Fired when integration data processing is completed (e.g., demographics)
     */
    trackIntegrationDataCompleted(input: IntegrationDataCompletedEventProps) {
      dispatch.analyticsScribe.trackEventV2({
        event_name: TrackingEventName.IntegrationDataCompleted,
        props: input,
      });
    },
    trackIntegrationDataRetrieved(input: IntegrationDataRetrievedEventProps) {
      trackIntegrationDataRetrievedHost(input);
    },

    /**
     * Track integration data failed event
     * Fired when integration data retrieval fails (e.g., patient sessions, demographics)
     */
    trackIntegrationDataFailed(input: IntegrationDataFailedEventProps) {
      trackIntegrationDataFailedHost(input);
    },
    trackContactSalesFormOpened(input: ContactSalesFormOpenedEventProps) {
      trackContactSalesFormOpenedHost(input);
    },
    trackContactSalesFormSubmitted(input: { form_id: string }) {
      trackContactSalesFormSubmittedHost(input);
    },
    trackIntegrationPatientSelected(input: IntegrationPatientSelectedEventProps) {
      trackIntegrationPatientSelectedHost(input);
    },
    trackIntegrationSessionCreated(input: IntegrationSessionCreatedEventProps) {
      trackIntegrationSessionCreatedHost(input);
    },
    trackIntegrationWidgetAuthStepCompleted(
      input: IntegrationWidgetAuthStepCompletedEventProps
    ) {
      trackIntegrationWidgetAuthStepCompletedHost(input);
    },
    trackIntegrationWidgetAuthStepErrored(
      input: IntegrationWidgetAuthStepErroredEventProps
    ) {
      trackIntegrationWidgetAuthStepErroredHost(input);
    },
    trackIntegrationWidgetAuthStepMisc(input: IntegrationWidgetAuthStepMiscEventProps) {
      trackIntegrationWidgetAuthStepMiscHost(input);
    },
    trackNoteSynced(input: IntegrationNoteSyncedEventProps) {
      trackNoteSyncedHost(input);
    },
    trackNoteSyncFailed(input: IntegrationNoteSyncedEventProps) {
      trackNoteSyncFailedHost(input);
    },
    trackNoteReverted(input: NoteRevertedEventProps) {
      trackNoteRevertedHost(input);
    },
  }),
});
